// Importaciones de Componentes y LibreríassetBloqueoOpcion_1
// import React, { useState, createContext } from 'react';
import React, { useEffect, useState, useRef, createContext } from 'react';
import { Container, Button } from 'react-bootstrap';
import { BsArrowLeftCircleFill, BsArrowRightCircleFill} from 'react-icons/bs';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactDOM from 'react-dom';
import { slide as Menu } from 'react-burger-menu';
import * as d3 from 'd3';
import './App.css';


// Imágenes de las Pantallas
import img0 from './img/Calculadora_0.jpg';
import img1 from './img/Calculadora_1.jpg';
import img2 from './img/Calculadora_2.jpg';
import img3 from './img/Calculadora_3.jpg';
import img4 from './img/EPILOC.png';
import img5 from './img/Anestesicos.jpg';
import img6 from './img/Lidocaina.jpg';
import img7 from './img/Mepivacaina.jpg';
import img8 from './img/Bupivacaina.jpg';
import img9 from './img/Levobupivacaina.jpg';
import img10 from './img/Ropivacaina.jpg';
import img11 from './img/Consejos.jpg';
import img12 from './img/Cateteres.jpg';
import img13 from './img/DOC.jpg';
import img14 from './img/Referencias.jpg';
import img15 from './img/Bibliografia.jpg';
import img16 from './img/Jeringa.png';


// Parámetros de Contexto Aplicación
export const BloqueoContext = createContext({
  bloqueoOpcion_1: null,
  bloqueoOpcion_2: null,
  bloqueoOpcion_3: null,
  bloqueoComplementario: null,
  video_1: null,
  video_2: null,
  video_3: null,
  video_4: null,
  video_5: null,
 
  setBloqueoOpcion_1: () => {},
  setBloqueoOpcion_2: () => {},
  setBloqueoOpcion_3: () => {},
  setBloqueoComplementario: () => {},
  setvideo_1: () => {},
  setvideo_2: () => {},
  setvideo_3: () => {},
  setvideo_4: () => {},
  setvideo_5: () => {},
});



const App = () => {

  // Inicializaciones
  
  // Declaraciones
  const paginas = 7;                                    // Número de Páginas de Navegación (Aplicación Principal)
  const [currentPage, setCurrentPage] = useState(0);    // Página Actual

  
  // --- Salidas ----

  //--- Datos Según Selección ---
  
  // Bloqueos, Anestésicos, Adyuvantes  y Vídeos
  const [bloqueoOpcion_1, setBloqueoOpcion_1] = useState(null);
  const [bloqueoOpcion_2, setBloqueoOpcion_2] = useState(null);
  const [bloqueoOpcion_3, setBloqueoOpcion_3] = useState(null);
  const [bloqueoComplementario, setBloqueoComplementario] = useState(null);  
  const [video_1, setVideo_1] = useState(null);
  const [video_2, setVideo_2] = useState(null);
  const [video_3, setVideo_3] = useState(null);
  const [video_4, setVideo_4] = useState(null);
  const [video_5, setVideo_5] = useState(null);

  // Peso Paciente
  const [peso_paciente, setPesoPaciente] = useState(null);

  // Volumen Inyección a Administrar y Unidades según Técnica de Bloqueo Seleccionada
  const [volumenAdministrar, setVolumenAdministrar] = useState(null);          // Volumen Según Técnica de Bloqueo
  const [tec_bloqueo_unidad, setTecBloqueoUnidad] = useState(null);
  
  // Dosis de Anestésico y Unidades según Anestésico Seleccionado
  const [Dosis, setDosis] = useState(null);                                    // Dosis Según Anestésico
  const [anestesico_unidades, setAnestesicoUnidades] = useState(null);

 // Dosis de Adyuvante y Unidades según Adyuvante Seleccionado
 const [DosisAdyuvante, setDosisAdyuvante] = useState(null);                    // Dosis Según Adyuvante
 const [adyuvante_unidades, setAdyuvanteUnidades] = useState(null);

 //--- Resultados ---

 // Volumen total en jeringuilla
 const [volumen_total, setVolumenTotal] = useState(null);         // Si Volumen Adyuvante (ml_adyuvante_M2) < 0 => "ERROR" en otro caso cargar_K2 (SI(Cálculos!M2<0;"ERROR";Cálculos!K2))

 // Anestésico
 const [anestesico_ml, setAnestesicoMl] = useState(null);
 const [anestesico_desc, setAnestesicoDesc] = useState(null);
 
 // Adyuvante
 const [adyuvante_ml, setAdyuvanteMl] = useState(null);
 const [adyuvante_desc, setAdyuvanteDesc] = useState(null);

 // Suero
 const [suero_ml, setSueroMl] = useState(null);
 const [suero_desc, setSueroDesc] = useState(null);

 // Puntos Inyección
 const [puntos_inyeccion, setPuntosInyeccion] = useState(null);

 // Volumen por punto de inyección
 const [volumen_punto, setVolumenPunto] = useState(null);

 // Aguja Recomendada
 const [aguja_rec, setAgujaRec] = useState(null);


  //-----------------

  // --- Entradas ---

  // Peso Paciente
    const [pesoPaciente, setpesoPaciente] = useState(null);
  
 
  //--- Tablas ---

  //Tablas Página 2

  // Tabla de Bloqueos (Anestesia)
  const [bloqueo, setBloqueo] = useState([
    {procedimiento:'Cirugía auricular', opcion_1:'Auricular mayor+auriculo-temporal', opcion_2:'', opcion_3:'', complementario:''},
    {procedimiento:'Cirugía espinal lumbar', opcion_1:'Erector espinal', opcion_2:'Epidural lumbosacra alta', opcion_3:'Epidural sacrococcígea alta', complementario:''},
    {procedimiento:'Cirugía espinal torácica', opcion_1:'Erector espinal', opcion_2:'', opcion_3:'', complementario:''},
    {procedimiento:'Cirugía cola/zona perineal', opcion_1:'Epidural sacrococcígea caudal', opcion_2:'Epidural lumbosacra caudal', opcion_3:'', complementario:''},
    {procedimiento:'Cirugía abdominal', opcion_1:'Cuadrado lumbar', opcion_2:'Epidural lumbosacra alta', opcion_3:'TAP Block', complementario:''},
    {procedimiento:'Drenaje torácico', opcion_1:'Interpleural', opcion_2:'Intercostal', opcion_3:'', complementario:''},
    {procedimiento:'Cirugía torácica', opcion_1:'Interpleural', opcion_2:'Intercostal', opcion_3:'', complementario:''},
    {procedimiento:'Laparoscopia', opcion_1:'Cuadrado lumbar', opcion_2:'TAP Block', opcion_3:'Epidural lumbosacra caudal', complementario:''},
    {procedimiento:'Cesárea', opcion_1:'Cuadrado lumbar', opcion_2:'Epidural lumbosacra caudal', opcion_3:'TAP Block', complementario:''},
    {procedimiento:'Mastectomía', opcion_1:'TAP Block', opcion_2:'', opcion_3:'', complementario:'Serrato ventral'},
    {procedimiento:'OHT', opcion_1:'Cuadrado lumbar', opcion_2:'TAP Block', opcion_3:'Epidural lumbosacra caudal', complementario:''},
    {procedimiento:'Piómetra', opcion_1:'Cuadrado lumbar', opcion_2:'TAP Block', opcion_3:'Epidural lumbosacra caudal', complementario:''},
    {procedimiento:'Amputación miembro anterior subtotal', opcion_1:'Subescalénico', opcion_2:'Axilar', opcion_3:'', complementario:''},
    {procedimiento:'Amputación miembro anterior con escapulectomía', opcion_1:'Paravertebral C6 -T1', opcion_2:'Subescalénico', opcion_3:'Axilar', complementario:''},
    {procedimiento:'Cirugía pélvica/coxofemoral/sacral', opcion_1:'Epidural sacrococcígea caudal', opcion_2:'Epidural lumbosacra caudal', opcion_3:'', complementario:''},
    {procedimiento:'Cirugía codo', opcion_1:'RUMM', opcion_2:'Subescalénico', opcion_3:'', complementario:''},
    {procedimiento:'Cirugía rodilla', opcion_1:'Ciático+femoral', opcion_2:'Epidural lumbosacra caudal', opcion_3:'', complementario:''},
    {procedimiento:'Cirugía hombro', opcion_1:'Paravertebral C6 -T1', opcion_2:'Subescalénico', opcion_3:'', complementario:''},
    {procedimiento:'Cirugía  húmero', opcion_1:'Axilar', opcion_2:'Subescalénico', opcion_3:'', complementario:''},
    {procedimiento:'Cirugía radio-cúbito', opcion_1:'RUMM', opcion_2:'Subescalénico', opcion_3:'', complementario:''},
    {procedimiento:'Cirugía fémur', opcion_1:'Ciático+femoral', opcion_2:'Epidural lumbosacra caudal', opcion_3:'Epidural sacrococcígea caudal', complementario:''},
    {procedimiento:'Cirugía tibia', opcion_1:'Ciático+femoral', opcion_2:'Epidural lumbosacra caudal', opcion_3:'Epidural sacrococcígea caudal', complementario:''},
    {procedimiento:'Cirugía carpo', opcion_1:'RUMM', opcion_2:'Subescalénico', opcion_3:'', complementario:''},
    {procedimiento:'Cirugía tarso', opcion_1:'Ciático+femoral', opcion_2:'Epidural lumbosacra caudal', opcion_3:'Epidural sacrococcígea caudal', complementario:''},
    {procedimiento:'Enucleación', opcion_1:'Retrobulbar', opcion_2:'', opcion_3:'', complementario:''},
    {procedimiento:'Cirugía oral / maxilar rostral', opcion_1:'Maxilar abordaje infraorbitario', opcion_2:'Maxilar abordaje intraoral', opcion_3:'', complementario:''},
    {procedimiento:'Cirugía oral maxilar completa', opcion_1:'Maxilar abordaje infraorbitario', opcion_2:'Maxilar abordaje intraoral', opcion_3:'', complementario:''},
    {procedimiento:'Cirugía mandibular rostral', opcion_1:'Alveolar inferior abordaje mentoniano', opcion_2:'', opcion_3:'', complementario:'Alveolar inferior abordaje mentoniano'},
    {procedimiento:'Cirugía mandibular completa', opcion_1:'Alveolar inferior abordaje mandibular', opcion_2:'', opcion_3:'', complementario:''},
    {procedimiento:'Rinoscopia', opcion_1:'Maxilar abordaje infraorbitario', opcion_2:'', opcion_3:'', complementario:''},
      ]);
  const [selectedBloqueo, setSelectedBloqueo] = useState('');

const videos = [
	{tipo_bloqueo:'Alveolar inferior abordaje mandibular', video_1:'https://vimeo.com/519545091', video_2:''},		
	{tipo_bloqueo:'Alveolar inferior abordaje mentoniano', video_1:'https://vimeo.com/519850203', video_2:''},		
	{tipo_bloqueo:'Auricular mayor+auriculo-temporal', video_1:'https://vimeo.com/519855709', video_2:''},		
	{tipo_bloqueo:'Axilar', video_1:'https://vimeo.com/519860525', video_2:''},		
	{tipo_bloqueo:'Irrigación postquirúrgica', video_1:'https://vimeo.com/519858505', video_2:''},		
	{tipo_bloqueo:'Ciático+femoral', video_1:'https://vimeo.com/519857521', video_2:'https://vimeo.com/519857733'},		
	{tipo_bloqueo:'Cuadrado lumbar', video_1:'', video_2:''},		
	{tipo_bloqueo:'Epidural lumbosacra alta', video_1:'https://vimeo.com/519856152', video_2:''},		
	{tipo_bloqueo:'Epidural lumbosacra caudal', video_1:'https://vimeo.com/519856152', video_2:''},		
	{tipo_bloqueo:'Epidural sacrococcígea alta', video_1:'https://vimeo.com/519857266', video_2:''},		
	{tipo_bloqueo:'Epidural sacrococcígea caudal', video_1:'https://vimeo.com/519857266', video_2:''},		
	{tipo_bloqueo:'Erector espinal', video_1:'', video_2:''},		
	{tipo_bloqueo:'Intercostal', video_1:'https://vimeo.com/519858794', video_2:''},		
	{tipo_bloqueo:'Interpleural', video_1:'https://vimeo.com/519860133', video_2:''},		
	{tipo_bloqueo:'Maxilar abordaje infraorbitario', video_1:'https://vimeo.com/519845878', video_2:''},		
	{tipo_bloqueo:'Maxilar abordaje intraoral', video_1:'https://vimeo.com/519850699', video_2:''},		
	{tipo_bloqueo:'Paravertebral C6-T1', video_1:'', video_2:''},		
	{tipo_bloqueo:'Retrobulbar', video_1:'https://vimeo.com/519855135', video_2:''},		
	{tipo_bloqueo:'RUMM', video_1:'https://vimeo.com/519860782', video_2:''},		
	{tipo_bloqueo:'Serrato ventral', video_1:'https://vimeo.com/519860310', video_2:''},		
	{tipo_bloqueo:'Subescalénico', video_1:'https://vimeo.com/519860649', video_2:''},		
	{tipo_bloqueo:'TAP Block', video_1:'https://vimeo.com/519861265', video_2:''},		
  ];
const [selectedVideo, setSelectedVideo] = useState('');

// Tablas Página 4

// Tabla Técnicas de Bloqueo
const [tecnica_bloqueo, setTecnicaBloqueo] = useState([
  {Tecnica_de_Bloqueo:'Alveolar inferior abordaje mandibular', Volumen_de_inyección:'0,1', unidad:'mL/kg', N_puntos_de_inyección:'1', Rango_de_dosis:'medio', Aguja:'Lococare'},
  {Tecnica_de_Bloqueo:'Alveolar inferior abordaje mentoniano', Volumen_de_inyección:'0,1', unidad:'mL/kg', N_puntos_de_inyección:'1', Rango_de_dosis:'medio', Aguja:'Hipodérmica'},
  {Tecnica_de_Bloqueo:'Auricular mayor+auriculo-temporal', Volumen_de_inyección:'0,4', unidad:'mL/kg', N_puntos_de_inyección:'2', Rango_de_dosis:'alto', Aguja:'Lococare'},
  {Tecnica_de_Bloqueo:'Axilar', Volumen_de_inyección:'0,3', unidad:'mL/kg', N_puntos_de_inyección:'1', Rango_de_dosis:'medio', Aguja:'Lococare'},
  {Tecnica_de_Bloqueo:'Ciático+femoral', Volumen_de_inyección:'0,3', unidad:'mL/kg', N_puntos_de_inyección:'2', Rango_de_dosis:'medio', Aguja:'Lococare'},
  {Tecnica_de_Bloqueo:'Cuadrado lumbar', Volumen_de_inyección:'0,5', unidad:'mL/kg', N_puntos_de_inyección:'1', Rango_de_dosis:'alto', Aguja:'Lococare'},
  {Tecnica_de_Bloqueo:'Epidural lumbosacra alta', Volumen_de_inyección:'0,4', unidad:'mL/kg', N_puntos_de_inyección:'1', Rango_de_dosis:'alto', Aguja:'Epicare'},
  {Tecnica_de_Bloqueo:'Epidural lumbosacra caudal', Volumen_de_inyección:'0,2', unidad:'mL/kg', N_puntos_de_inyección:'1', Rango_de_dosis:'medio', Aguja:'Epicare'},
  {Tecnica_de_Bloqueo:'Epidural sacrococcígea alta', Volumen_de_inyección:'0,4', unidad:'mL/kg', N_puntos_de_inyección:'1', Rango_de_dosis:'alto', Aguja:'Epicare'},
  {Tecnica_de_Bloqueo:'Epidural sacrococcígea caudal', Volumen_de_inyección:'0,2', unidad:'mL/kg', N_puntos_de_inyección:'1', Rango_de_dosis:'medio', Aguja:'Epicare'},
  {Tecnica_de_Bloqueo:'Erector espinal', Volumen_de_inyección:'0,4', unidad:'mL/kg', N_puntos_de_inyección:'1', Rango_de_dosis:'alto', Aguja:'Lococare'},
  {Tecnica_de_Bloqueo:'Intercostal', Volumen_de_inyección:'0,5', unidad:'mL/kg', N_puntos_de_inyección:'5', Rango_de_dosis:'alto', Aguja:'Hipodérmica'},
  {Tecnica_de_Bloqueo:'Interpleural', Volumen_de_inyección:'0,2', unidad:'mL/kg', N_puntos_de_inyección:'1', Rango_de_dosis:'medio', Aguja:'Epicare'},
  {Tecnica_de_Bloqueo:'Irrigación postquirúrgica', Volumen_de_inyección:'0,5', unidad:'mL/kg', N_puntos_de_inyección:'1', Rango_de_dosis:'alto', Aguja:'Catéter'},
  {Tecnica_de_Bloqueo:'Maxilar abordaje infraorbitario', Volumen_de_inyección:'0,1', unidad:'mL/kg', N_puntos_de_inyección:'1', Rango_de_dosis:'bajo', Aguja:'Hipodérmica'},
  {Tecnica_de_Bloqueo:'Maxilar abordaje intraoral', Volumen_de_inyección:'0,1', unidad:'mL/kg', N_puntos_de_inyección:'1', Rango_de_dosis:'bajo', Aguja:'Hipodérmica'},
  {Tecnica_de_Bloqueo:'Paravertebral C6-T1', Volumen_de_inyección:'0,3', unidad:'mL/kg', N_puntos_de_inyección:'1', Rango_de_dosis:'medio', Aguja:'Lococare'},
  {Tecnica_de_Bloqueo:'Retrobulbar', Volumen_de_inyección:'0,2', unidad:'mL/kg', N_puntos_de_inyección:'1', Rango_de_dosis:'medio', Aguja:'Hipodérmica'},
  {Tecnica_de_Bloqueo:'RUMM', Volumen_de_inyección:'0,3', unidad:'mL/kg', N_puntos_de_inyección:'2', Rango_de_dosis:'medio', Aguja:'Lococare'},
  {Tecnica_de_Bloqueo:'Serrato ventral', Volumen_de_inyección:'0,4', unidad:'mL/kg', N_puntos_de_inyección:'1', Rango_de_dosis:'alto', Aguja:'Lococare'},
  {Tecnica_de_Bloqueo:'Subescalénico', Volumen_de_inyección:'0,4', unidad:'mL/kg', N_puntos_de_inyección:'1', Rango_de_dosis:'alto', Aguja:'Lococare'},
  {Tecnica_de_Bloqueo:'TAP Block', Volumen_de_inyección:'0,5', unidad:'mL/kg', N_puntos_de_inyección:'2', Rango_de_dosis:'alto', Aguja:'Lococare'},  
]);
const [selectedTecnicaBloqueo, setSelectedTecnicaBloqueo] = useState('');  

// Tablas Página 5

// Tabla Anestésico
const [anestesico, setAnestesico] = useState([
  {Anestesico:'Lidocaína', Presentacion:'Lidocaína 2%', Conc_mg_por_mL:'20', Dosis_bajo_vol:'2', Dosis_vol_medio:'4', Dosis_alto_vol:'6', unidades:'mg/kg'},
  {Anestesico:'Lidocaína', Presentacion:'Lidocaína 1%', Conc_mg_por_mL:'10', Dosis_bajo_vol:'2', Dosis_vol_medio:'4', Dosis_alto_vol:'6', unidades:'mg/kg'},
  {Anestesico:'Lidocaína', Presentacion:'Lidocaína 5%', Conc_mg_por_mL:'50', Dosis_bajo_vol:'2', Dosis_vol_medio:'4', Dosis_alto_vol:'6', unidades:'mg/kg'},
  {Anestesico:'Mepivacaína', Presentacion:'Mepivacaína 2%', Conc_mg_por_mL:'20', Dosis_bajo_vol:'2', Dosis_vol_medio:'3', Dosis_alto_vol:'4', unidades:'mg/kg'},
  {Anestesico:'Mepivacaína', Presentacion:'Mepivacaína 1%', Conc_mg_por_mL:'10', Dosis_bajo_vol:'2', Dosis_vol_medio:'3', Dosis_alto_vol:'4', unidades:'mg/kg'},
  {Anestesico:'Mepivacaína', Presentacion:'Mepivacaína 3%', Conc_mg_por_mL:'30', Dosis_bajo_vol:'2', Dosis_vol_medio:'3', Dosis_alto_vol:'4', unidades:'mg/kg'},
  {Anestesico:'Bupivacaína', Presentacion:'Bupivacaína 0.25%', Conc_mg_por_mL:'2,5', Dosis_bajo_vol:'1', Dosis_vol_medio:'1,5', Dosis_alto_vol:'2', unidades:'mg/kg'},
  {Anestesico:'Bupivacaína', Presentacion:'Bupivacaína 0.5%', Conc_mg_por_mL:'5', Dosis_bajo_vol:'1', Dosis_vol_medio:'1,5', Dosis_alto_vol:'2', unidades:'mg/kg'},
  {Anestesico:'Bupivacaína', Presentacion:'Bupivacaína 0.75%', Conc_mg_por_mL:'7,5', Dosis_bajo_vol:'1', Dosis_vol_medio:'1,5', Dosis_alto_vol:'2', unidades:'mg/kg'},
  {Anestesico:'Levobupivacaína', Presentacion:'Levobupivacaína 0,25%', Conc_mg_por_mL:'2,5', Dosis_bajo_vol:'1', Dosis_vol_medio:'1,5', Dosis_alto_vol:'2', unidades:'mg/kg'},
  {Anestesico:'Levobupivacaína', Presentacion:'Levobupivacaína 0,125%', Conc_mg_por_mL:'1,25', Dosis_bajo_vol:'1', Dosis_vol_medio:'1,5', Dosis_alto_vol:'2', unidades:'mg/kg'},
  {Anestesico:'Levobupivacaína', Presentacion:'Levobupivacaína 0,5%', Conc_mg_por_mL:'5', Dosis_bajo_vol:'1', Dosis_vol_medio:'1,5', Dosis_alto_vol:'2', unidades:'mg/kg'},
  {Anestesico:'Levobupivacaína', Presentacion:'Levobupivacaína 0,75%', Conc_mg_por_mL:'7,5', Dosis_bajo_vol:'1', Dosis_vol_medio:'1,5', Dosis_alto_vol:'2', unidades:'mg/kg'},
  {Anestesico:'Levobupivacaína', Presentacion:'Levobupivacaína 0,0625%', Conc_mg_por_mL:'0,625', Dosis_bajo_vol:'1', Dosis_vol_medio:'1,5', Dosis_alto_vol:'2', unidades:'mg/kg'},
  {Anestesico:'Ropivacaína', Presentacion:'Ropivacaína 1%', Conc_mg_por_mL:'10', Dosis_bajo_vol:'1', Dosis_vol_medio:'1,5', Dosis_alto_vol:'2', unidades:'mg/kg'},
  {Anestesico:'Ropivacaína', Presentacion:'Ropivacaína 0,75%', Conc_mg_por_mL:'7,5', Dosis_bajo_vol:'1', Dosis_vol_medio:'1,5', Dosis_alto_vol:'2', unidades:'mg/kg'},
  {Anestesico:'Ropivacaína', Presentacion:'Ropivacaína 0,2%', Conc_mg_por_mL:'2', Dosis_bajo_vol:'1', Dosis_vol_medio:'1,5', Dosis_alto_vol:'2', unidades:'mg/kg'},  
]);
const [selectedAnestesico, setSelectedAnestesico] = useState('');  

// Tablas Página 6

// Tabla Adyuvante
const [adyuvante, setAdyuvante] = useState([
  {Adyuvante:'Buprenorfina 0.3 mg/mL', Conc_mg_por_mL:'0,3', Dosis:'0,003', unidades:'mg/kg paciente', XXX:'', origen_cálculo:'A3'},
  {Adyuvante:'Dexametasona 4 mg/mL', Conc_mg_por_mL:'4', Dosis:'0,05', unidades:'mg/kg paciente', XXX:'', origen_cálculo:'A3'},
  {Adyuvante:'Dexmedetomidina 0.5 mg/mL', Conc_mg_por_mL:'500', Dosis:'1', unidades:'ug/mL AL', XXX:'AL', origen_cálculo:'C6'},
  {Adyuvante:'Ketamina 100 mg/mL', Conc_mg_por_mL:'100', Dosis:'0,25', unidades:'mg/kg paciente', XXX:'', origen_cálculo:'A3'},
  {Adyuvante:'Morfina 10 mg/mL', Conc_mg_por_mL:'10', Dosis:'0,1', unidades:'mg/kg paciente', XXX:'', origen_cálculo:'A3'},
  {Adyuvante:'Sin adyuvante', Conc_mg_por_mL:'0,0', Dosis:'0,0', unidades:'mg/kg paciente', XXX:'', origen_cálculo:'A3'},
  {Adyuvante:'Triamcinolona 40 mg/mL', Conc_mg_por_mL:'40', Dosis:'0,2', unidades:'mg/kg paciente', XXX:'', origen_cálculo:'A3'},  
]);
const [selectedAdyuvante, setSelectedAdyuvante] = useState('');  


// Tablas Página 7

// Tabla Aguja Hipodérmica (para: Cálculos O2)
const [aguja_hipodermica, setAgujaHipodermica] = useState([
  {Tecnica_de_bloqueo:'Retrobulbar', Seleccion_Aguja_Hipodermica:'Espinal'},
  {Tecnica_de_bloqueo:'Irrigación postquirúrgica', Seleccion_Aguja_Hipodermica:'Catéter irrigación'},
  {Tecnica_de_bloqueo:'Maxilar abordaje infraorbitario', Seleccion_Aguja_Hipodermica:'Catéter intravenoso 23 Ga'},
]);
const [selectedAgujaHipodermica, setSelectedAgujaHipodermica] = useState('');  

// Tabla Aguja (para: Cálculos P2 en caso Normal)
const [aguja, setAguja] = useState([
  {Key:'A-Epidural lumbosacra alta', Categ:'A', Peso_min:'1', Peso_max:'5', Bloqueo:'Epidural lumbosacra alta', Aguja:'EPICARE ES20050'},
  {Key:'A-Epidural lumbosacra caudal', Categ:'A', Peso_min:'1', Peso_max:'5', Bloqueo:'Epidural lumbosacra caudal', Aguja:'EPICARE ES20050'},
  {Key:'A-Interpleural', Categ:'A', Peso_min:'1', Peso_max:'5', Bloqueo:'Interpleural', Aguja:'EPICARE ES20050'},
  {Key:'A-Epidural sacrococcígea alta', Categ:'A', Peso_min:'1', Peso_max:'5', Bloqueo:'Epidural sacrococcígea alta', Aguja:'EPICARE ES20050 o LOCOCARE BN22050'},
  {Key:'A-Epidural sacrococcígea caudal', Categ:'A', Peso_min:'1', Peso_max:'5', Bloqueo:'Epidural sacrococcígea caudal', Aguja:'EPICARE ES20050 o LOCOCARE BN22050'},
  {Key:'A-RUMM', Categ:'A', Peso_min:'1', Peso_max:'5', Bloqueo:'RUMM', Aguja:'LOCOCARE BN22050'},
  {Key:'A-TAP Block', Categ:'A', Peso_min:'1', Peso_max:'5', Bloqueo:'TAP Block', Aguja:'LOCOCARE BN22050'},
  {Key:'A-Ciático+femoral', Categ:'A', Peso_min:'1', Peso_max:'5', Bloqueo:'Ciático+femoral', Aguja:'LOCOCARE BN22050'},
  {Key:'A-Erector espinal', Categ:'A', Peso_min:'1', Peso_max:'5', Bloqueo:'Erector espinal', Aguja:'LOCOCARE BN22050'},
  {Key:'A-Paravertebral C6-T1', Categ:'A', Peso_min:'1', Peso_max:'5', Bloqueo:'Paravertebral C6-T1', Aguja:'LOCOCARE BN22050'},
  {Key:'A-Cuadrado lumbar', Categ:'A', Peso_min:'1', Peso_max:'5', Bloqueo:'Cuadrado lumbar', Aguja:'LOCOCARE BN22050'},
  {Key:'A-Serrato ventral', Categ:'A', Peso_min:'1', Peso_max:'5', Bloqueo:'Serrato ventral', Aguja:'LOCOCARE BN22050'},
  {Key:'A-Subescalénico', Categ:'A', Peso_min:'1', Peso_max:'5', Bloqueo:'Subescalénico', Aguja:'LOCOCARE BN22050'},
  {Key:'A-Auricular mayor+auriculo-temporal', Categ:'A', Peso_min:'1', Peso_max:'5', Bloqueo:'Auricular mayor+auriculo-temporal', Aguja:'LOCOCARE BN22050'},
  {Key:'A-Intercostal', Categ:'A', Peso_min:'1', Peso_max:'5', Bloqueo:'Intercostal', Aguja:'LOCOCARE BN22050'},
  {Key:'A-Alveolar inferior abordaje mandibular', Categ:'A', Peso_min:'1', Peso_max:'5', Bloqueo:'Alveolar inferior abordaje mandibular', Aguja:'LOCOCARE BN22050 o Hipodérmica 25 Ga (naranja)'},
  {Key:'A-Alveolar inferior abordaje mentoniano', Categ:'A', Peso_min:'1', Peso_max:'5', Bloqueo:'Alveolar inferior abordaje mentoniano', Aguja:'LOCOCARE BN22050 o Hipodérmica 25 Ga (naranja)'},
  {Key:'A-Axilar', Categ:'A', Peso_min:'1', Peso_max:'5', Bloqueo:'Axilar', Aguja:'LOCOCARE BN22050'},
  {Key:'B-Epidural lumbosacra alta', Categ:'B', Peso_min:'5,1', Peso_max:'8', Bloqueo:'Epidural lumbosacra alta', Aguja:'EPICARE ES22080'},
  {Key:'B-Epidural lumbosacra caudal', Categ:'B', Peso_min:'5,1', Peso_max:'8', Bloqueo:'Epidural lumbosacra caudal', Aguja:'EPICARE ES22080'},
  {Key:'B-Interpleural', Categ:'B', Peso_min:'5,1', Peso_max:'8', Bloqueo:'Interpleural', Aguja:'EPICARE ES22080'},
  {Key:'B-Epidural sacrococcígea alta', Categ:'B', Peso_min:'5,1', Peso_max:'8', Bloqueo:'Epidural sacrococcígea alta', Aguja:'EPICARE ES22080 o LOCOCARE BN22050'},
  {Key:'B-Epidural sacrococcígea caudal', Categ:'B', Peso_min:'5,1', Peso_max:'8', Bloqueo:'Epidural sacrococcígea caudal', Aguja:'EPICARE ES22080 o LOCOCARE BN22050'},
  {Key:'B-RUMM', Categ:'B', Peso_min:'5,1', Peso_max:'8', Bloqueo:'RUMM', Aguja:'LOCOCARE BN22070 o LOCOCARE BN22050'},
  {Key:'B-TAP Block', Categ:'B', Peso_min:'5,1', Peso_max:'8', Bloqueo:'TAP Block', Aguja:'LOCOCARE BN22070 o LOCOCARE BN22050'},
  {Key:'B-Ciático+femoral', Categ:'B', Peso_min:'5,1', Peso_max:'8', Bloqueo:'Ciático+femoral', Aguja:'LOCOCARE BN22070 o LOCOCARE BN22050'},
  {Key:'B-Erector espinal', Categ:'B', Peso_min:'5,1', Peso_max:'8', Bloqueo:'Erector espinal', Aguja:'LOCOCARE BN22070 o LOCOCARE BN22050'},
  {Key:'B-Paravertebral C6-T1', Categ:'B', Peso_min:'5,1', Peso_max:'8', Bloqueo:'Paravertebral C6-T1', Aguja:'LOCOCARE BN22070 o LOCOCARE BN22050'},
  {Key:'B-Cuadrado lumbar', Categ:'B', Peso_min:'5,1', Peso_max:'8', Bloqueo:'Cuadrado lumbar', Aguja:'LOCOCARE BN22070 o LOCOCARE BN22050'},
  {Key:'B-Serrato ventral', Categ:'B', Peso_min:'5,1', Peso_max:'8', Bloqueo:'Serrato ventral', Aguja:'LOCOCARE BN22070 o LOCOCARE BN22050'},
  {Key:'B-Subescalénico', Categ:'B', Peso_min:'5,1', Peso_max:'8', Bloqueo:'Subescalénico', Aguja:'LOCOCARE BN22070 o LOCOCARE BN22050'},
  {Key:'B-Auricular mayor+auriculo-temporal', Categ:'B', Peso_min:'5,1', Peso_max:'8', Bloqueo:'Auricular mayor+auriculo-temporal', Aguja:'LOCOCARE BN22070 o LOCOCARE BN22050'},
  {Key:'B-Intercostal', Categ:'B', Peso_min:'5,1', Peso_max:'8', Bloqueo:'Intercostal', Aguja:'LOCOCARE BN22070 o LOCOCARE BN2205'},
  {Key:'B-Alveolar inferior abordaje mandibular', Categ:'B', Peso_min:'5,1', Peso_max:'8', Bloqueo:'Alveolar inferior abordaje mandibular', Aguja:'LOCOCARE BN22070 o Hipodérmica 25 Ga (naranja)'},
  {Key:'B-Alveolar inferior abordaje mentoniano', Categ:'B', Peso_min:'5,1', Peso_max:'8', Bloqueo:'Alveolar inferior abordaje mentoniano', Aguja:'LOCOCARE BN22070 o Hipodérmica 25 Ga (naranja)'},
  {Key:'B-Axilar', Categ:'B', Peso_min:'5,1', Peso_max:'8', Bloqueo:'Axilar', Aguja:'LOCOCARE BN22070'},
  {Key:'C-Epidural lumbosacra alta', Categ:'C', Peso_min:'8,1', Peso_max:'15', Bloqueo:'Epidural lumbosacra alta', Aguja:'EPICARE ES20080'},
  {Key:'C-Epidural lumbosacra caudal', Categ:'C', Peso_min:'8,1', Peso_max:'15', Bloqueo:'Epidural lumbosacra caudal', Aguja:'EPICARE ES20080'},
  {Key:'C-Interpleural', Categ:'C', Peso_min:'8,1', Peso_max:'15', Bloqueo:'Interpleural', Aguja:'EPICARE ES20080'},
  {Key:'C-Epidural sacrococcígea alta', Categ:'C', Peso_min:'8,1', Peso_max:'15', Bloqueo:'Epidural sacrococcígea alta', Aguja:'EPICARE ES20050 o LOCOCARE BN22050'},
  {Key:'C-Epidural sacrococcígea caudal', Categ:'C', Peso_min:'8,1', Peso_max:'15', Bloqueo:'Epidural sacrococcígea caudal', Aguja:'EPICARE ES20050 o LOCOCARE BN22050'},
  {Key:'C-RUMM', Categ:'C', Peso_min:'8,1', Peso_max:'15', Bloqueo:'RUMM', Aguja:'LOCOCARE BN22070'},
  {Key:'C-TAP Block', Categ:'C', Peso_min:'8,1', Peso_max:'15', Bloqueo:'TAP Block', Aguja:'LOCOCARE BN22070'},
  {Key:'C-Ciático+femoral', Categ:'C', Peso_min:'8,1', Peso_max:'15', Bloqueo:'Ciático+femoral', Aguja:'LOCOCARE BN22070'},
  {Key:'C-Erector espinal', Categ:'C', Peso_min:'8,1', Peso_max:'15', Bloqueo:'Erector espinal', Aguja:'LOCOCARE BN22070'},
  {Key:'C-Paravertebral C6-T1', Categ:'C', Peso_min:'8,1', Peso_max:'15', Bloqueo:'Paravertebral C6-T1', Aguja:'LOCOCARE BN22070'},
  {Key:'C-Cuadrado lumbar', Categ:'C', Peso_min:'8,1', Peso_max:'15', Bloqueo:'Cuadrado lumbar', Aguja:'LOCOCARE BN22070'},
  {Key:'C-Serrato ventral', Categ:'C', Peso_min:'8,1', Peso_max:'15', Bloqueo:'Serrato ventral', Aguja:'LOCOCARE BN22070'},
  {Key:'C-Subescalénico', Categ:'C', Peso_min:'8,1', Peso_max:'15', Bloqueo:'Subescalénico', Aguja:'LOCOCARE BN22070'},
  {Key:'C-Auricular mayor+auriculo-temporal', Categ:'C', Peso_min:'8,1', Peso_max:'15', Bloqueo:'Auricular mayor+auriculo-temporal', Aguja:'LOCOCARE BN22070'},
  {Key:'C-Intercostal', Categ:'C', Peso_min:'8,1', Peso_max:'15', Bloqueo:'Intercostal', Aguja:'LOCOCARE BN22070'},
  {Key:'C-Alveolar inferior abordaje mandibular', Categ:'C', Peso_min:'8,1', Peso_max:'15', Bloqueo:'Alveolar inferior abordaje mandibular', Aguja:'LOCOCARE BN22070 o Hipodérmica 25 Ga (naranja)'},
  {Key:'C-Alveolar inferior abordaje mentoniano', Categ:'C', Peso_min:'8,1', Peso_max:'15', Bloqueo:'Alveolar inferior abordaje mentoniano', Aguja:'LOCOCARE BN22070 o Hipodérmica 25 Ga (naranja)'},
  {Key:'C-Axilar', Categ:'C', Peso_min:'8,1', Peso_max:'15', Bloqueo:'Axilar', Aguja:'LOCOCARE BN22070'},
  {Key:'D-Epidural lumbosacra alta', Categ:'D', Peso_min:'15,1', Peso_max:'25', Bloqueo:'Epidural lumbosacra alta', Aguja:'EPICARE ES18050TU'},
  {Key:'D-Epidural lumbosacra caudal', Categ:'D', Peso_min:'15,1', Peso_max:'25', Bloqueo:'Epidural lumbosacra caudal', Aguja:'EPICARE ES18050TU'},
  {Key:'D-Interpleural', Categ:'D', Peso_min:'15,1', Peso_max:'25', Bloqueo:'Interpleural', Aguja:'EPICARE ES18050TU'},
  {Key:'D-Epidural sacrococcígea alta', Categ:'D', Peso_min:'15,1', Peso_max:'25', Bloqueo:'Epidural sacrococcígea alta', Aguja:'EPICARE ES20050 o LOCOCARE BN22050'},
  {Key:'D-Epidural sacrococcígea caudal', Categ:'D', Peso_min:'15,1', Peso_max:'25', Bloqueo:'Epidural sacrococcígea caudal', Aguja:'EPICARE ES20050 o LOCOCARE BN22050'},
  {Key:'D-RUMM', Categ:'D', Peso_min:'15,1', Peso_max:'25', Bloqueo:'RUMM', Aguja:'LOCOCARE BN21090'},
  {Key:'D-TAP Block', Categ:'D', Peso_min:'15,1', Peso_max:'25', Bloqueo:'TAP Block', Aguja:'LOCOCARE BN21090'},
  {Key:'D-Ciático+femoral', Categ:'D', Peso_min:'15,1', Peso_max:'25', Bloqueo:'Ciático+femoral', Aguja:'LOCOCARE BN21090'},
  {Key:'D-Erector espinal', Categ:'D', Peso_min:'15,1', Peso_max:'25', Bloqueo:'Erector espinal', Aguja:'LOCOCARE BN21090'},
  {Key:'D-Paravertebral C6-T1', Categ:'D', Peso_min:'15,1', Peso_max:'25', Bloqueo:'Paravertebral C6-T1', Aguja:'LOCOCARE BN21090'},
  {Key:'D-Cuadrado lumbar', Categ:'D', Peso_min:'15,1', Peso_max:'25', Bloqueo:'Cuadrado lumbar', Aguja:'LOCOCARE BN21090'},
  {Key:'D-Serrato ventral', Categ:'D', Peso_min:'15,1', Peso_max:'25', Bloqueo:'Serrato ventral', Aguja:'LOCOCARE BN21090'},
  {Key:'D-Subescalénico', Categ:'D', Peso_min:'15,1', Peso_max:'25', Bloqueo:'Subescalénico', Aguja:'LOCOCARE BN21090'},
  {Key:'D-Auricular mayor+auriculo-temporal', Categ:'D', Peso_min:'15,1', Peso_max:'25', Bloqueo:'Auricular mayor+auriculo-temporal', Aguja:'LOCOCARE BN21090'},
  {Key:'D-Intercostal', Categ:'D', Peso_min:'15,1', Peso_max:'25', Bloqueo:'Intercostal', Aguja:'LOCOCARE BN21090'},
  {Key:'D-Alveolar inferior abordaje mandibular', Categ:'D', Peso_min:'15,1', Peso_max:'25', Bloqueo:'Alveolar inferior abordaje mandibular', Aguja:'LOCOCARE BN22090 o Hipodérmica 23 Ga (azul)'},
  {Key:'D-Alveolar inferior abordaje mentoniano', Categ:'D', Peso_min:'15,1', Peso_max:'25', Bloqueo:'Alveolar inferior abordaje mentoniano', Aguja:'LOCOCARE BN22090 o Hipodérmica 23 Ga (azul)'},
  {Key:'D-Axilar', Categ:'D', Peso_min:'15,1', Peso_max:'25', Bloqueo:'Axilar', Aguja:'LOCOCARE BN21090'},
  {Key:'E-Epidural lumbosacra alta', Categ:'E', Peso_min:'Superior a', Peso_max:'25', Bloqueo:'Epidural lumbosacra alta', Aguja:'EPICARE ES18080TU'},
  {Key:'E-Epidural lumbosacra caudal', Categ:'E', Peso_min:'Superior a', Peso_max:'25', Bloqueo:'Epidural lumbosacra caudal', Aguja:'EPICARE ES18080TU'},
  {Key:'E-Interpleural', Categ:'E', Peso_min:'Superior a', Peso_max:'25', Bloqueo:'Interpleural', Aguja:'EPICARE ES18080TU'},
  {Key:'E-Epidural sacrococcígea alta', Categ:'E', Peso_min:'Superior a', Peso_max:'25', Bloqueo:'Epidural sacrococcígea alta', Aguja:'EPICARE ES18080TU o LOCOCARE BN22070'},
  {Key:'E-Epidural sacrococcígea caudal', Categ:'E', Peso_min:'Superior a', Peso_max:'25', Bloqueo:'Epidural sacrococcígea caudal', Aguja:'EPICARE ES18080TU o LOCOCARE BN22070'},
  {Key:'E-RUMM', Categ:'E', Peso_min:'Superior a', Peso_max:'25', Bloqueo:'RUMM', Aguja:'LOCOCARE BN21090'},
  {Key:'E-TAP Block', Categ:'E', Peso_min:'Superior a', Peso_max:'25', Bloqueo:'TAP Block', Aguja:'LOCOCARE BN21090'},
  {Key:'E-Ciático+femoral', Categ:'E', Peso_min:'Superior a', Peso_max:'25', Bloqueo:'Ciático+femoral', Aguja:'LOCOCARE BN21090'},
  {Key:'E-Erector espinal', Categ:'E', Peso_min:'Superior a', Peso_max:'25', Bloqueo:'Erector espinal', Aguja:'LOCOCARE BN21090'},
  {Key:'E-Paravertebral C6-T1', Categ:'E', Peso_min:'Superior a', Peso_max:'25', Bloqueo:'Paravertebral C6-T1', Aguja:'LOCOCARE BN21140'},
  {Key:'E-Cuadrado lumbar', Categ:'E', Peso_min:'Superior a', Peso_max:'25', Bloqueo:'Cuadrado lumbar', Aguja:'LOCOCARE BN21140'},
  {Key:'E-Serrato ventral', Categ:'E', Peso_min:'Superior a', Peso_max:'25', Bloqueo:'Serrato ventral', Aguja:'LOCOCARE BN21140'},
  {Key:'E-Subescalénico', Categ:'E', Peso_min:'Superior a', Peso_max:'25', Bloqueo:'Subescalénico', Aguja:'LOCOCARE BN21140'},
  {Key:'E-Auricular mayor+auriculo-temporal', Categ:'E', Peso_min:'Superior a', Peso_max:'25', Bloqueo:'Auricular mayor+auriculo-temporal', Aguja:'LOCOCARE BN21090'},
  {Key:'E-Intercostal', Categ:'E', Peso_min:'Superior a', Peso_max:'25', Bloqueo:'Intercostal', Aguja:'LOCOCARE BN22070 o Hipodérmica 23 Ga (azul)'},
  {Key:'E-Alveolar inferior abordaje mandibular', Categ:'E', Peso_min:'Superior a', Peso_max:'25', Bloqueo:'Alveolar inferior abordaje mandibular', Aguja:'LOCOCARE BN22070 o Hipodérmica 23 Ga (azul)'},
  {Key:'E-Alveolar inferior abordaje mentoniano', Categ:'E', Peso_min:'Superior a', Peso_max:'25', Bloqueo:'Alveolar inferior abordaje mentoniano', Aguja:'LOCOCARE BN22070 o Hipodérmica 23 Ga (azul)'},
  {Key:'E-Axilar', Categ:'E', Peso_min:'Superior a', Peso_max:'25', Bloqueo:'Axilar', Aguja:'LOCOCARE BN21140'},  
]);

// Tabla Hipodermica (para: Cálculos P2 caso Hipodérmica)

const [hipodermica, setHipodermica] = useState([
  {Key:'X-Maxilar abordaje infraorbitario', Categ:'X', Peso_min:'0', Peso_max:'2', Bloqueo:'Maxilar abordaje infraorbitario', Aguja:'Hipodérmica 30 Ga (morada)'},
  {Key:'X-Maxilar abordaje intraoral', Categ:'X', Peso_min:'0', Peso_max:'2', Bloqueo:'Maxilar abordaje intraoral', Aguja:'Hipodérmica 30 Ga (morada)'},
  {Key:'X-Alveolar inferior abordaje mentoniano', Categ:'X', Peso_min:'0', Peso_max:'2', Bloqueo:'Alveolar inferior abordaje mentoniano', Aguja:'Hipodérmica 30 Ga (morada)'},
  {Key:'Y-Maxilar abordaje infraorbitario', Categ:'Y', Peso_min:'2,1', Peso_max:'10', Bloqueo:'Maxilar abordaje infraorbitario', Aguja:'Hipodérmica 25 Ga (naranja)'},
  {Key:'Y-Maxilar abordaje intraoral', Categ:'Y', Peso_min:'2,1', Peso_max:'10', Bloqueo:'Maxilar abordaje intraoral', Aguja:'Hipodérmica 25 Ga (naranja)'},
  {Key:'Y-Alveolar inferior abordaje mentoniano', Categ:'Y', Peso_min:'2,1', Peso_max:'10', Bloqueo:'Alveolar inferior abordaje mentoniano', Aguja:'Hipodérmica 25 Ga (naranja)'},
  {Key:'Z-Maxilar abordaje infraorbitario', Categ:'Z', Peso_min:'10,1', Peso_max:'100', Bloqueo:'Maxilar abordaje infraorbitario', Aguja:'Hipodérmica 23 Ga (azul)'},
  {Key:'Z-Maxilar abordaje intraoral', Categ:'Z', Peso_min:'10,1', Peso_max:'100', Bloqueo:'Maxilar abordaje intraoral', Aguja:'Hipodérmica 23 Ga (azul)'},
  {Key:'Z-Alveolar inferior abordaje mentoniano', Categ:'Z', Peso_min:'10,1', Peso_max:'100', Bloqueo:'Alveolar inferior abordaje mentoniano', Aguja:'Hipodérmica 23 Ga (azul)'},  
]);

// Versión 8.3 - Nueva tabla añadida a Bloqueo con los casos a considerar para la comparativa (NOTAS-4 / CAMBIOS-4)

const [comparativa, setComparativa] = useState([
  {Tecnica_de_Bloqueo:'Alveolar inferior abordaje mandibular'},
  {Tecnica_de_Bloqueo:'Alveolar inferior abordaje mentoniano'},
  {Tecnica_de_Bloqueo:'Maxilar abordaje infraorbitario'},
  {Tecnica_de_Bloqueo:'Maxilar abordaje intraoral'},  
]);

  //--- FUNCIONES ---

function convertirNumeroStringAFloat(numeroString) {
  // Reemplazar la coma por un punto
  const numeroFloat = parseFloat(numeroString.replace(',', '.'));

  // Verificar si el resultado es un número válido
  if (isNaN(numeroFloat)) {
    return null; // Opcional: devolver un valor por defecto en caso de no poder convertir
  }

  return numeroFloat;
}

function convertirFloatANumeroString(numeroFloat) {
  // Convertir el número a una cadena
  const numeroString = numeroFloat.toString();

  // Reemplazar el punto por una coma
  const numeroStringComa = numeroString.replace('.', ',');

  return numeroStringComa;
}

function roundToDecimal(number, decimalPlaces) {
  const factor = 10 ** decimalPlaces;
  return Math.round(number * factor) / factor;
}

// --- COMPONENTES ---

  // Componente de Búsqueda
  const Buscar = ({ tabla, campoBusqueda, valorBusqueda, campoRetorno }) => {
    // Buscar en la tabla el registro que coincida con el valorBusqueda
    const registroEncontrado = tabla.find(registro => registro[campoBusqueda] === valorBusqueda);
  
    // Si se encontró un registro que coincida, retorna el valor del campoRetorno. Si no, retorna null.
    return registroEncontrado ? registroEncontrado[campoRetorno] : null;
  };
  
  // Evento de Búsqueda
  const handleSearch = (event) => {
    setSelectedBloqueo(event.target.value);       // Bloqueo Seleccionado
    // Execute your search logic here

  };
    // Evento de Búsqueda
    const handleSearchTecnica = (event) => {
      setSelectedTecnicaBloqueo(event.target.value);       // Técnica Bloqueo Seleccionada
      // Execute your search logic here

    };
    //------------------ 

    // Evento de Búsqueda
    const handleSearchAnestesico = (event) => {
      setSelectedAnestesico(event.target.value);       // Anestésico Seleccionado
      // Execute your search logic here
  
    };
    //------------------ 

    // Evento de Búsqueda
    const handleSearchAdyuvante = (event) => {
      setSelectedAdyuvante(event.target.value);       // Adyuvante Seleccionado
      // Execute your search logic here
  
    };

    //------------------ 
    
    //--- Calcula Valores Pantalla 6 ---

    const calcularValores_6 = () => {
      // Cálculo de la Dosis de Adyuvante

      // llamar a la función Buscar para obtener la Dosis del Adyuvante
      let dosis_adyuvante = '0,0';
      if (selectedAdyuvante !== "Sin adyuvante") {
        dosis_adyuvante = Buscar({ tabla: adyuvante, campoBusqueda:'Adyuvante', valorBusqueda: selectedAdyuvante, campoRetorno: 'Dosis'}); 
      }
      setDosisAdyuvante(dosis_adyuvante);
  
      
      // llamar a la función Buscar para obtener las unidades del Adyuvante
      const unidades_adyuvante = Buscar({ tabla: adyuvante, campoBusqueda:'Adyuvante', valorBusqueda: selectedAdyuvante, campoRetorno:'unidades' }); 
      setAdyuvanteUnidades(unidades_adyuvante);
     }

    //--- TRIGGER PARA LA ACTUALIZACION DE LOS CAMPOS ---
    useEffect(() => {
      calcularValores_6();
    }, [selectedAdyuvante]); // Esto se ejecutará cada vez que selectedAnestesico cambie  
  
    //------------------ 
    //--- Calcula Valores Pantalla 5 ---

    // Función que calcula el Rango de dosis en función del Volumen de Inyección

    function calcularNombreCampo(volumenInyeccion) {
      if (volumenInyeccion === '0,1') {
          return "Dosis_bajo_vol";
      } 
      else if (volumenInyeccion === '0,2' || volumenInyeccion === '0,3') {
          return "Dosis_vol_medio";
      } 
      else if (volumenInyeccion > '0,3') {
          return "Dosis_alto_vol";
      } 
      else {
          return "error";
      }
  }

    const calcularValores_5 = () => {
      // Cálculo de la Dosis de Anestésico

      // llamar a la función Buscar para obtener la Dosis del Anestésico
      let campo_buscar = calcularNombreCampo(volumenAdministrar);
      const dosis = Buscar({ tabla: anestesico, campoBusqueda:'Presentacion', valorBusqueda: selectedAnestesico, campoRetorno: campo_buscar}); 
      setDosis(dosis);
  
      // llamar a la función Buscar para obtener las unidades del Anestésico
      const unidades = Buscar({ tabla: anestesico, campoBusqueda:'Presentacion', valorBusqueda: selectedAnestesico, campoRetorno:'unidades' }); 
      setAnestesicoUnidades(unidades);
      // Inicializa Adyuvante
      setSelectedAdyuvante(null)
      setDosisAdyuvante(null)
      setAdyuvanteUnidades(null)
     }

    //--- TRIGGER PARA LA ACTUALIZACION DE LOS CAMPOS ---
    useEffect(() => {
      calcularValores_5();
    }, [selectedAnestesico]); // Esto se ejecutará cada vez que selectedAnestesico cambie  
  
    //------------------ 

    //--- Calcula ValorEs Pantalla 4 ---

    const calcularValores_4 = () => {
      // llamar a la función Buscar para obtener el volumen de inyección según Técnica de Bloqueo
      const volumen_administrar = Buscar({ tabla: tecnica_bloqueo, campoBusqueda:'Tecnica_de_Bloqueo', valorBusqueda: selectedTecnicaBloqueo, campoRetorno:'Volumen_de_inyección' });
      setVolumenAdministrar(volumen_administrar);    
      // llamar a la función Buscar para obtener la unidad según Técnica de Bloqueo
      const unidad = Buscar({ tabla: tecnica_bloqueo, campoBusqueda:'Tecnica_de_Bloqueo', valorBusqueda: selectedTecnicaBloqueo, campoRetorno:'unidad' });
      setTecBloqueoUnidad(unidad);
      // Inicializa Anestésico
      setSelectedAnestesico(null)
      setDosis(null)
      setAnestesicoUnidades(null)
      
    }
    //--- TRIGGER PARA LA ACTUALIZACION DE LOS CAMPOS ---
    useEffect(() => {
      calcularValores_4();
    }, [selectedTecnicaBloqueo]); // Esto se ejecutará cada vez que selectedTecnicaBloqueo cambie  

    //------------------ 
  
    //--- Calcula Valores Pantalla 2 ---

    const calcularValores_2 = () => {
      // llamar a la función Buscar para cada uno de los bloqueos y usar los setters para actualizar el estado.
      
      const opcion_1 = Buscar({ tabla: bloqueo, campoBusqueda:'procedimiento', valorBusqueda: selectedBloqueo, campoRetorno:'opcion_1' });
      const opcion_2 = Buscar({ tabla: bloqueo, campoBusqueda:'procedimiento', valorBusqueda: selectedBloqueo, campoRetorno:'opcion_2' });
      const opcion_3 = Buscar({ tabla: bloqueo, campoBusqueda:'procedimiento', valorBusqueda: selectedBloqueo, campoRetorno:'opcion_3' });
      const complementario = Buscar({ tabla: bloqueo, campoBusqueda:'procedimiento', valorBusqueda: selectedBloqueo, campoRetorno:'complementario' });      
      const video_1 =  Buscar({tabla: videos, campoBusqueda: 'tipo_bloqueo', valorBusqueda: opcion_1, campoRetorno: 'video_1'});
      const video_2 =  Buscar({tabla: videos, campoBusqueda: 'tipo_bloqueo', valorBusqueda: opcion_1, campoRetorno: 'video_2'});
      const video_3 =  Buscar({tabla: videos, campoBusqueda: 'tipo_bloqueo', valorBusqueda: opcion_2, campoRetorno: 'video_1'});
      const video_4 =  Buscar({tabla: videos, campoBusqueda: 'tipo_bloqueo', valorBusqueda: opcion_3, campoRetorno: 'video_1'});
      const video_5 =  Buscar({tabla: videos, campoBusqueda: 'tipo_bloqueo', valorBusqueda: complementario, campoRetorno: 'video_1'});      
      setBloqueoOpcion_1(opcion_1);
      setBloqueoOpcion_2(opcion_2);
      setBloqueoOpcion_3(opcion_3);
      setBloqueoComplementario(complementario);
      setVideo_1(video_1);
      setVideo_2(video_2);
      setVideo_3(video_3);
      setVideo_4(video_4);
      setVideo_5(video_5);
      setSelectedTecnicaBloqueo(opcion_1);              // Control Cambio Técnica de Bloqueo
      // Inicializa Peso Paciente
      setPesoPaciente(null)
      // Ajusta Técnica de Bloqueo (Pantalla 4)
      calcularValores_4();
    }
      //--- TRIGGER PARA LA ACTUALIZACION DE LOS CAMPOS ---
    useEffect(() => {
      calcularValores_2();      
    }, [selectedBloqueo]); // Esto se ejecutará cada vez que selectedBloqueo cambie  

    //------------------ 
    // Funciones Auxiliares para Calcular Resultados 
    function CategorizarPesoPaciente_H2(peso_paciente) {
      switch (true) {
          case (peso_paciente <= 5):
              return 'A';
          case (peso_paciente > 5 && peso_paciente <= 8):
              return 'B';
          case (peso_paciente > 8.1 && peso_paciente <= 15):
              return 'C';
          case (peso_paciente > 15.1 && peso_paciente <= 25):
              return 'D';
          case (peso_paciente > 25):
              return 'E';
          default:
              return 'F';
      }
  }
  
  function CategorizarProcedimientoBloqueo(tecnica_bloqueo, peso_paciente) {
    if (tecnica_bloqueo === "Maxilar abordaje infraorbitario") {
      if (peso_paciente <= 2) {
        return 'X';
      } else if (peso_paciente > 2 && peso_paciente <= 10) {
        return 'Y';
      } else if (peso_paciente > 10) {
        return 'Z';
      }
    } else if (tecnica_bloqueo === "Maxilar abordaje intraoral") {
      if (peso_paciente <= 2) {
        return 'X';
      } else if (peso_paciente > 2 && peso_paciente <= 10) {
        return 'Y';
      } else if (peso_paciente > 10) {
        return 'Z';
      }
    } else if (tecnica_bloqueo === "Alveolar inferior abordaje mentoniano") {
      if (peso_paciente <= 2) {
        return 'X';
      } else if (peso_paciente > 2 && peso_paciente <= 10) {
        return 'Y';
      } else if (peso_paciente > 10) {
        return 'Z';
      }
    } else {
      return 'no hipodermica';
    }
  }
  
    // Calcular Resultados
    const CalcularResultados = () => {
      let cargar_K2 = convertirNumeroStringAFloat(peso_paciente) * convertirNumeroStringAFloat(volumenAdministrar) // Peso Paciente * Volumen Inyección (Bloqueo)
      // Peso Paciente * Dosis Anestésico / Conc. Anestésico mg/ml
      let anest_L2 = convertirNumeroStringAFloat(peso_paciente) * convertirNumeroStringAFloat(Dosis) / convertirNumeroStringAFloat(Buscar({ tabla: anestesico, campoBusqueda:'Presentacion', valorBusqueda: selectedAnestesico, campoRetorno: 'Conc_mg_por_mL'}));
      let ml_adyuvante_M2 = cargar_K2 - anest_L2;
      let volumen_adyuvante_J2 = 0.0
      if (selectedAdyuvante !== "Sin adyuvante") {
          //### Sugerencia Errónea: volumen_adyuvante_J2 = convertirNumeroStringAFloat(peso_paciente) * convertirNumeroStringAFloat(DosisAdyuvante) / convertirNumeroStringAFloat(Buscar({ tabla: adyuvante, campoBusqueda:'Adyuvante', valorBusqueda: selectedAdyuvante, campoRetorno: 'Conc_mg_por_mL'}))
          let conc_adyuvante = convertirNumeroStringAFloat(Buscar({ tabla: adyuvante, campoBusqueda:'Adyuvante', valorBusqueda: selectedAdyuvante, campoRetorno: 'Conc_mg_por_mL'}))
          let adyuvante_dex_I2 = Buscar({tabla: adyuvante, campoBusqueda: 'Adyuvante' ,valorBusqueda: selectedAdyuvante, campoRetorno: 'XXX'})
          if (adyuvante_dex_I2 == "AL") { 
            volumen_adyuvante_J2 = anest_L2 / conc_adyuvante
          }
          else
          {
            volumen_adyuvante_J2 = convertirNumeroStringAFloat(peso_paciente) * convertirNumeroStringAFloat(DosisAdyuvante) / conc_adyuvante
          }
        }  

      // ml de Anestésico

      if (Buscar({ tabla: comparativa, campoBusqueda:'Tecnica_de_Bloqueo', valorBusqueda: selectedTecnicaBloqueo, campoRetorno: 'Tecnica_de_Bloqueo'}) != null ) {
        setAnestesicoMl(convertirFloatANumeroString(roundToDecimal(0.1 + (convertirNumeroStringAFloat(peso_paciente) / 100), 2)));  // CAMBIOS-5.- Solicitado por Alfon Dic-2023 (Versión 9 Excel), se modifica la fórmula del Anestésico en la hoja excel (Sin documentarlo).
      }
      else {
        if (ml_adyuvante_M2 < 0) {
          // Modificado a Petición de Alfon, se procesará en caso de Error de Anestésico
          // setAnestesicoMl('');
          setAnestesicoMl(convertirFloatANumeroString(roundToDecimal(anest_L2, 2)));
        }
        else {
          setAnestesicoMl(convertirFloatANumeroString(roundToDecimal(anest_L2, 2)));
        }
      }
      setAnestesicoDesc(selectedAnestesico)

      // ml de Adyuvante
      if (ml_adyuvante_M2 < 0) {
        // setAdyuvanteMl('');  ### Modificado a Petición Alfon 06/09/2023 ya que M2 en hoja es cambiado a "ERROR" => 0 Nunca será < 0
        setAdyuvanteMl(convertirFloatANumeroString(roundToDecimal(volumen_adyuvante_J2, 2)));
      }
      else {
        setAdyuvanteMl(convertirFloatANumeroString(roundToDecimal(volumen_adyuvante_J2, 2)));
      }
      setAdyuvanteDesc(selectedAdyuvante)

      // ml de Suero
      if (Buscar({ tabla: comparativa, campoBusqueda:'Tecnica_de_Bloqueo', valorBusqueda: selectedTecnicaBloqueo, campoRetorno: 'Tecnica_de_Bloqueo'}) != null ) {
        setSueroMl(convertirFloatANumeroString(roundToDecimal(0.0, 2)));    // CAMBIOS-4.-  Modifico fórmula para que cuando la técnica sea de bajo volumen el SSF sea siempre =0, si no daba incongruencia
      }
      else {
        if (ml_adyuvante_M2 < 0) {
          // Modificado a Petición de Alfon, se procesará en caso de Error de Anestésico
          // setSueroMl('');
          setSueroMl(convertirFloatANumeroString(roundToDecimal(ml_adyuvante_M2, 2)));
        }
        else {
          setSueroMl(convertirFloatANumeroString(roundToDecimal(ml_adyuvante_M2, 2)));
        }
      }
      setSueroDesc('SSF')

      // Puntos Inyección
      let num_puntos_inyeccion = Buscar({ tabla: tecnica_bloqueo, campoBusqueda:'Tecnica_de_Bloqueo', valorBusqueda: selectedTecnicaBloqueo, campoRetorno:'N_puntos_de_inyección'})
      setPuntosInyeccion(num_puntos_inyeccion);
      
      // Volumen por Cada Punto Inyección en ml
      if (ml_adyuvante_M2 < 0) {
        // setVolumenPunto('');  ### Modificado a Petición Alfon 06/09/2023 ya que M2 en hoja es cambiado a "ERROR" => 0 Nunca será < 0
        setVolumenPunto(convertirFloatANumeroString(roundToDecimal(cargar_K2 / convertirNumeroStringAFloat(num_puntos_inyeccion), 2)));
      }
      else {
        setVolumenPunto(convertirFloatANumeroString(roundToDecimal(cargar_K2 / convertirNumeroStringAFloat(num_puntos_inyeccion), 2)));
      }

      // Volumen a Cargar en Jeringa
      if (Buscar({ tabla: comparativa, campoBusqueda:'Tecnica_de_Bloqueo', valorBusqueda: selectedTecnicaBloqueo, campoRetorno: 'Tecnica_de_Bloqueo'}) != null ) {
        let suma_volumenes =   0.1 + (convertirNumeroStringAFloat(peso_paciente) / 100) + volumen_adyuvante_J2;      // Versión 8.3 - NOTAS-4	- Si CALCU:C3= Bloqueos:A2, A3, A16 o A17, entonces G6=0.1+ CALCU A3/100
        // IMPORTANTE !!!: CONSIDERADAS IMPRECISIONES DEL MODELO RESPECTO A LAS SUMAS DE VOLUMENES: "+ volumen_adyuvante_J2" Corrige imprecisiones 
        setVolumenTotal(convertirFloatANumeroString(roundToDecimal(suma_volumenes, 2)));
        setVolumenPunto(convertirFloatANumeroString(roundToDecimal(suma_volumenes / convertirNumeroStringAFloat(num_puntos_inyeccion), 2))); 
        if ((volumen_adyuvante_J2 < 0.01) && (selectedAdyuvante != "Sin adyuvante")) {                // Versión 8.3 - NOTAS-1 - si CALCU:C7 < 0.01, "ERROR: Usar un adyuvante más diluido
          // Modificado a Petición de Alfon, se procesará en caso de Error de Anestésico
          // setSueroMl('');
          // setVolumenTotal('');
          // setAdyuvanteMl('');
          // setPuntosInyeccion('');
          // setVolumenPunto('');

          // Mostrar Valores a petición de Alfon
          let suma_volumenes =   0.1 + (convertirNumeroStringAFloat(peso_paciente) / 100) + volumen_adyuvante_J2;      // Versión 8.3 - NOTAS-4	- Si CALCU:C3= Bloqueos:A2, A3, A16 o A17, entonces G6=0.1+ CALCU A3/100
          // IMPORTANTE !!!: CONSIDERADAS IMPRECISIONES DEL MODELO RESPECTO A LAS SUMAS DE VOLUMENES: "+ volumen_adyuvante_J2" Corrige imprecisiones 
          setVolumenTotal(convertirFloatANumeroString(roundToDecimal(suma_volumenes, 2)));
          setVolumenPunto(convertirFloatANumeroString(roundToDecimal(suma_volumenes / convertirNumeroStringAFloat(num_puntos_inyeccion), 2))); 
          toast.error('EL ADYUVANTE SELECCIONADO NO PUEDE CARGARSE CON PRECISIÓN. CONSIDERAR UNA DILUCIÓN DEL MISMO.');
        } 	
      }
      else {
        if (ml_adyuvante_M2 < 0) { 
          //--- Solicitado por Alfon Dic-2023 - No borar datos  ---
          // setVolumenTotal('');
          // setAnestesicoMl('');
          // setAdyuvanteMl('');
          // setSueroMl('');
          // setPuntosInyeccion('');
          // setVolumenPunto('');

          //--- Solicitado por Alfon Dic-2023 - No borar datos  ---
          //--- Ajustes para corregir imprecisiones en el modelo al obviar volumen adyuvante ---
          // setVolumenTotal(convertirFloatANumeroString(cargar_K2));
          ml_adyuvante_M2 = 0.0;
          if (volumen_adyuvante_J2 < 0) {
            volumen_adyuvante_J2 = 0.0;
          }
          setSueroMl(convertirFloatANumeroString(roundToDecimal(0.0, 2)));
          let suma_volumenes = anest_L2 + volumen_adyuvante_J2 + ml_adyuvante_M2;
          setVolumenTotal(convertirFloatANumeroString(roundToDecimal(suma_volumenes, 2)))
          setVolumenPunto(convertirFloatANumeroString(roundToDecimal(suma_volumenes / convertirNumeroStringAFloat(num_puntos_inyeccion), 2)));
          //--------------------------------------------------------
          // toast.error('ES POSIBLE QUE TENGAS QUE UTILIZAR UN ANESTÉSICO MÁS CONCENTRADO, NO OBSTANTE REVISA LOS PARAMETROS INTRODUCIDOS');
          toast.error('RECOMENDABLE USAR UN ANESTÉSICO LOCAL MÁS CONCENTRADO, NO OBSTANTE REVISA LOS PARAMETROS INTRODUCIDOS');
        }
        else {
          if ((volumen_adyuvante_J2 < 0.01) && (selectedAdyuvante != "Sin adyuvante")) {                // Versión 8.3 - NOTAS-1 - si CALCU:C7 < 0.01, "ERROR: Usar un adyuvante más diluido
            // Modificado a Petición de Alfon, se procesará en caso de Error de Anestésico
            // setVolumenTotal('');
            // setAdyuvanteMl('');
            // setPuntosInyeccion('');
            // setVolumenPunto('');
            let suma_volumenes = anest_L2 + volumen_adyuvante_J2 + ml_adyuvante_M2;
            setVolumenTotal(convertirFloatANumeroString(roundToDecimal(suma_volumenes, 2)))
            setVolumenPunto(convertirFloatANumeroString(roundToDecimal(suma_volumenes / convertirNumeroStringAFloat(num_puntos_inyeccion), 2)));
            toast.error('EL ADYUVANTE SELECCIONADO NO PUEDE CARGARSE CON PRECISIÓN. CONSIDERAR UNA DILUCIÓN DEL MISMO.');
          }
          else {
            //--- Ajustes para corregir imprecisiones en el modelo al obviar volumen adyuvante ---
            // setVolumenTotal(convertirFloatANumeroString(cargar_K2));
            let suma_volumenes = anest_L2 + volumen_adyuvante_J2 + ml_adyuvante_M2;
            setVolumenTotal(convertirFloatANumeroString(roundToDecimal(suma_volumenes, 2)))
            setVolumenPunto(convertirFloatANumeroString(roundToDecimal(suma_volumenes / convertirNumeroStringAFloat(num_puntos_inyeccion), 2)));
          }
          //--------------------------------------------------------
        }
      }

      //--- Aguja Recomendada ---

      // seleccion_aguja_hipodermica_O2
      let aguja_hipodermica_O2 = Buscar({ tabla: aguja_hipodermica, campoBusqueda:'Tecnica_de_bloqueo', valorBusqueda: selectedTecnicaBloqueo, campoRetorno:'Seleccion_Aguja_Hipodermica'})
      if (!aguja_hipodermica_O2 || aguja_hipodermica_O2 === '') {
          aguja_hipodermica_O2 ='buscar aguja normal';
        }
      // Cálculo peso_tipo_normal_H2
      let peso_tipo_normal_H2 = CategorizarPesoPaciente_H2(convertirNumeroStringAFloat(peso_paciente))

      // Cálculo peso_tipo_hipo_H3
      let peso_tipo_hipo_H3 = CategorizarProcedimientoBloqueo(selectedTecnicaBloqueo, convertirNumeroStringAFloat(peso_paciente))

      // Cálculo cat_peso_N2
      let cat_peso_N2 = peso_tipo_normal_H2;        // Para fines de Inicialización
      if (peso_tipo_hipo_H3 === "no hipodermica")  {
            cat_peso_N2 = peso_tipo_normal_H2;
      }
      else {
          cat_peso_N2 = peso_tipo_hipo_H3;
      }
      // toast.success(cat_peso_N2);      // Test
      
      // aguja_normal_P2
      let aguja_normal_P2 = "XXXXXXX"   // Para fines de Inicialización
      let clave = cat_peso_N2 + "-" + selectedTecnicaBloqueo;
      // toast.success(clave);      // Test
      if (cat_peso_N2 > 'F') {    // Aguja Hipodérmica
        aguja_normal_P2 = Buscar({tabla: hipodermica, campoBusqueda: "Key", valorBusqueda: clave, campoRetorno: "Aguja"})
      }
      else {                      // Aguja Normal
        aguja_normal_P2 = Buscar({tabla: aguja, campoBusqueda: "Key", valorBusqueda: clave, campoRetorno: "Aguja"})
      }
      // toast.success(aguja_normal_P2);      // Test

      // Actualización de Aguja Recomendada en Pantalla 7
      if (aguja_hipodermica_O2 === "buscar aguja normal") {
        setAgujaRec(aguja_normal_P2)
      }
      else {
        setAgujaRec(aguja_hipodermica_O2)
      }
    }

    //------------------ 

    const BotonEnlace = ({ texto, enlace }) => (
      <a href={enlace} target="_blank" rel="noopener noreferrer">
        <button>{texto}</button>
      </a>
    );
    

// Control de Página Siguiente
const handleNextPage = (NumPag) => {
  if (NumPag !== undefined) {
    setCurrentPage(NumPag);
  } else if (currentPage < paginas) { // El número aquí es el número de la última página
    if ((!bloqueoOpcion_1 || bloqueoOpcion_1.trim() === '') && currentPage === 2) {
      toast.error('SELECCIONAR PROCEDIMIENTO');
    } 
    else if ((!peso_paciente || peso_paciente.trim() === '') && currentPage === 3) {
      toast.error('INTRODUCIR EL PESO DEL PACIENTE');
    } 
    else if ((!volumenAdministrar || volumenAdministrar.trim() === '') && currentPage === 4) {
      toast.error('NO SE HA ESTABLECIDO EL VOLUMEN A ADMINISTRAR - SELECCIONAR TECNICA DE BLOQUEO');
    } 
    else if ((!Dosis || Dosis.trim() === '') && currentPage == 5) {
      toast.error('NO SE HA ESTABLECIDO LA DOSIS DE ANESTESICO - SELECCIONAR ANESTESICO');
    } 
    else if ((!DosisAdyuvante || DosisAdyuvante.trim() === '') && currentPage === 6 && selectedAdyuvante !== "Sin adyuvante") {
        toast.error('NO SE HA ESTABLECIDO LA DOSIS DE ADYUVANTE - SELECCIONAR ADYUVANTE');
    } 
    else {
      if (currentPage === 6) {
        if (selectedAdyuvante !== "Sin adyuvante") {
          setAdyuvanteMl(0.0)
        } 
        CalcularResultados();
      }
      setCurrentPage(currentPage + 1);
    }
  }
};


// Control de Página Anterior
const handlePreviousPage = (NumPag) => {
  if (NumPag !== undefined) {
    setCurrentPage(NumPag);
  } else if ((currentPage > 1) && (currentPage <= paginas)) { // El número aquí es el número de la primera página
      setCurrentPage(currentPage - 1);
  }
};

    //--- Botón de Video ---

  const VideoButton = ({ link, label, labelClassName, buttonClassName }) => {

    const handleClick = () => {
      if (link) {
        window.open(link, "_blank");
      }
    };
  
    return (
      <div className="video-button-container" style={{ display: 'flex', alignItems: 'center' }}>
        <span className={labelClassName}>{label}</span>
        <button className={buttonClassName} onClick={handleClick}>
          <div className="video-button-arrow"></div>
        </button>
    </div>
    )};

    const VideoTransparentButton = ({ link, label, labelClassName, buttonClassName }) => {

      const handleClick = () => {
        if (link) {
          window.open(link, "_blank");
        }
      };
    
      return (
        <div className="video-button-container" style={{ display: 'flex', alignItems: 'center' }}>
          <span className={labelClassName}>{label}</span>
          <button className={buttonClassName} onClick={handleClick}>
            <div className="video-button-transparent-arrow"></div>
          </button>
      </div>
      )};          
  
// Código para el movimiento manual de las pantallas
let touchStartX = null;

const onTouchStart = (e) => {
  touchStartX = e.touches[0].clientX;
};

const onTouchMove = (e) => {
  if (touchStartX === null) {
    return;
  }
  
  let touchEndX = e.touches[0].clientX;

  // Diferencia entre el inicio y el fin del toque.
  let diffX = touchStartX - touchEndX;

  // Un umbral para determinar cuándo un movimiento cuenta como un deslizamiento
  const threshold = 150;

  if (diffX > threshold) {            // Movimiento a la izquierda
    handleNextPage();
    touchStartX = null;               // Reseteamos el valor para el próximo toque.
  } else if (diffX < -threshold) {    // Movimiento a la derecha
    handlePreviousPage();
    touchStartX = null;               // Reseteamos el valor para el próximo toque.
  }
};
//----------------------------------------------------

  // Renderizador de Páginas
  const renderPageContent = () => {
    let pageContent;
    let imgSrc;

// Botón "Entendido"
  
  // Función para fijar la página 
  function ir_a_pagina(n_page) {
    setCurrentPage(n_page)
  }

function ButtonEntendido() {
  return (
    <Button 
      className="button-entendido" 
      onClick={() => {
        // toast.success('Procesando');
        ir_a_pagina(1);
      }}
    >
      Entendido
    </Button>
  );  
}

function ButtonLidocaina() {
  return (
    <Button 
      className="button-anestesico button-lidocaina" 
      onClick={() => ir_a_pagina(9)}
    >
    LIDOCAINA
    </Button>
  ); 
}

function ButtonMepivacaina() {
  return (
    <Button 
      className="button-anestesico button-mepivacaina" 
      onClick={() => ir_a_pagina(10)}
    >
    MEPICACAINA
    </Button>
  ); 
}

function ButtonBupivacaina() {
  return (
    <Button 
      className="button-anestesico button-bupivacaina" 
      onClick={() => ir_a_pagina(11)}
    >
    BUPIVACAINA
    </Button>
  ); 
}

function ButtonLevobupivacaina() {
  return (
    <Button 
      className="button-anestesico button-levobupivacaina" 
      onClick={() => ir_a_pagina(12)}
    >
    LEVOBUPIVACAINA
    </Button>
  ); 
}

function ButtonRopivacaina() {
  return (
    <Button 
      className="button-anestesico button-ropivacaina" 
      onClick={() => ir_a_pagina(13)}
    >
    ROPIVACAINA
    </Button>
  ); 
}

// Botón Siguiente Primera Pantalla
function ButtonNexSingle({ NumPag }) {
  return (
    <Button 
      className="custom-button custom-button-next_s" 
      onClick={() => handleNextPage(NumPag)}
    >
      <BsArrowRightCircleFill />
    </Button>
  );
}
  
// Botón Previo Pantallas Intermedias
function ButtonPrev2({ NumPag }) {
  return (
    <Button className="custom-button custom-button-prev_2" onClick={() => handlePreviousPage(NumPag)}>
      <BsArrowLeftCircleFill />
    </Button>
  );
}

// Botón Siguiente Pantallas Intermedias
function ButtonNext2({ NumPag }) {
  return (
    <Button className="custom-button custom-button-next_2" onClick={() => handleNextPage(NumPag)}>
      <BsArrowRightCircleFill />
    </Button>
  );
}

// Botón Previo Pantallas Finales
function ButtonPrevSingle({ NumPag }) {
  return (
    <Button className="custom-button custom-button-prev_s" onClick={() => handlePreviousPage(NumPag)}>
      <BsArrowLeftCircleFill />
    </Button>
  );
}

// Selectores (pop-down)

  // Selector del Tipo de Bloqueo
  function SelectionBloqueo() {
    return (
      <div className="select_bloqueo_wrapper">
        <select className="select_bloqueo" value={selectedBloqueo} onChange={handleSearch}>
          <option value=""></option>
          {bloqueo.map((item) => (
            <option key={item.procedimiento} value={item.procedimiento}>
              {item.procedimiento}
            </option>
          ))}
        </select> 
      </div>
    );
  }

    // Selector del Técnica de Bloqueo
    function SelectionTecnicaBloqueo() {
      return (
        <div className="select_tec_bloqueo_wrapper">
          <select className="select_tec_bloqueo" value={selectedTecnicaBloqueo} onChange={handleSearchTecnica}>
            <option value="">{bloqueoOpcion_1}</option>
            {tecnica_bloqueo.map((item) => (
              <option key={item.Tecnica_de_Bloqueo} value={item.Tecnica_de_Bloqueo}>
                {item.Tecnica_de_Bloqueo}
              </option>
            ))}
          </select> 
        </div>
      );
    }

    // Selector del Anestésico
    function SelectionAnestesico() {
      return (
        <div className="select_anestesico_wrapper">
          <select className="select_anestesico" value={selectedAnestesico} onChange={handleSearchAnestesico}>
          <option value=""></option>
            {anestesico.map((item) => (
              <option key={item.Presentacion} value={item.Presentacion}>
                {item.Presentacion}
              </option>
            ))}
          </select> 
        </div>
      );
    }

    // Selector del Adyuvante
    function SelectionAdyuvante() {
      return (
        <div className="select_adyuvante_wrapper">
          <select className="select_adyuvante" value={selectedAdyuvante} onChange={handleSearchAdyuvante}>
          <option value=""></option>
            {adyuvante.map((item) => (
              <option key={item.Adyuvante} value={item.Adyuvante}>
                {item.Adyuvante}
              </option>
            ))}
          </select> 
        </div>
      );
    }

  //--- Links Zonas Pantalla 1 ---
  const LinkZona1 = () => (
    <a href="https://www.ecuphar.es" className='link-zona_1' />
  );
  const LinkZona2 = () => (
    <a href="https://vimeo.com/519861514" className='link-zona_2'/>
  );
  const LinkZona3 = () => (
    <a href="https://vimeo.com/519861621" className='link-zona_3' />
  );
  
  //--- Componentes de Tabla ---
  
  const TableComponent = ({ columnHeaders, rowData, style }) => {
  return (
    <table className="table">
      <thead>
        <tr>
          {columnHeaders.map((header, index) => (
            <th style={style} key={index}>{header}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rowData.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {row.map((cell, cellIndex) => (
              <td key={cellIndex}>{cell}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

function Table1Row({ textHeader, cellData, headerBackgroundColor, headerColor }) {
  const [TextHeader] = useState(textHeader);
  const [CellData] = useState(cellData);
  
  const style = {backgroundColor: headerBackgroundColor, color: headerColor}; // create a style object with the background color and the font color

  return (
    <div>
      <TableComponent style={style} columnHeaders={[TextHeader]} rowData={[[CellData]]} />
    </div>
  );
}


//--- Componentes de Menu ---
const MenuBurger = ({ options, pages, classes, handleNextPage }) => {

  const handleClick = (page) => {
      handleNextPage(page);
  };

  return (
    <div>
      <Menu>
        {options.map((option, index) => (
          <div
            key={option}
            className={classes[index]}
            onClick={() => handleClick(pages[index])}
          >
            {option}
          </div>
        ))}
      </Menu>
    </div>
  );
};

//----------------------------------
  
  //--- PAGINAS ---
  
  //--- PAGINA 0 (AVISO LEGAL) --- 
  function Pagina0() {
    return (
      <Container fluid> 
        <div className="container-align-center">
            <ButtonEntendido />
        </div>
      </Container>
    );
  }

  //--- PAGINA 1 ---
  function Pagina1() {
    return (
      <Container fluid> 
        <div className="container-align-end">
          <div className="custom-button-next_s">
            <ButtonNexSingle />
          </div>
          <div>
            <MenuBurger
              options={['Aviso Legal', 'Anestésicos Locales', 'Consejos útiles en Anestesia Locorregional', 'Catéteres', 'D.O.C. (Distancia Occípito-Coccígea)', 'Referencias', 'Bibliografía recomendada']}
              pages={[0, 8, 14, 15, 16, 17, 18]}
              classes={['menu-item', 'menu-item', 'menu-item', 'menu-item', 'menu-item', 'menu-item', 'menu-item']}
              handleNextPage={handleNextPage}
            />
          </div>
          <div>
            <LinkZona1/>
            <LinkZona2/>
            <LinkZona3/>
          </div>    
        </div>     
      </Container>
    );
  }

  //--- PAGINA 2 ---
  function BotonVideo({video, label_button, button_color, video_1, video_2}) {
    return(
      <div className="container-align-center">
        {video !== '' && video !== null	?
          (button_color === "yellow" ? 
            <VideoButton label= {label_button} link={video} labelClassName="label_video_yellow" buttonClassName="video-button-yellow"/> :					 
            <VideoButton label={label_button} link={video} labelClassName="label_video_blue" buttonClassName="video-button-blue"/>) :
            (video_1 !== '' && video !== null) || (video_2 !== '' && video_2 !== null) ? 
                <></>:
                <VideoTransparentButton label="" link="" labelClassName="" buttonClassName="transparent_button"/>  
        }
      </div>
    );
  }

    function Pagina2() {
      return (
        <Container fluid>
          <div className="container-align-end">
            <div className="custom-button-prev_2_2">
                    <ButtonPrev2 />
            </div>      
            <div className="custom-button-next_2_2">
                    <ButtonNext2 />
            </div>    			  
          </div>
          <div className="container-align-center">
            <p className="text_1 text_1_1">¿Qué&nbsp;técnica&nbsp;de&nbsp;<span class="extra-bold"><strong><br/>bloqueo</strong></span>&nbsp;necesitas?</p>
          </div>

          <div className="container-align-center">
            <p className="text_1 text_1_3">Procedimiento</p>
          </div>
          <div className="container-align-center">
            <SelectionBloqueo />
          </div>
          <div className="container-align-center">
            <Table1Row textHeader="Bloqueo opción 1" cellData={bloqueoOpcion_1} headerBackgroundColor="#00ABD9" headerColor="white" />
          </div>
          <div className="container-video-align-center">
            <BotonVideo 
                  video = {video_1}
                  label_button = 'Video 1'
                  button_color = 'blue' 
                  video_1 = {video_1}    
                  video_2 = {video_2}                               
                 />
                <BotonVideo 
                  video = {video_2}
                  label_button = 'Video 2'
                  button_color = 'blue' 
                 />
            </div>
          <div className="container-align-center">
            <Table1Row textHeader="Bloqueo opción 2" cellData={bloqueoOpcion_2} headerBackgroundColor="#FCC642" headerColor="black"/>  
          </div>
          <div className="container-video-align-center">
            <BotonVideo 
                    video = {video_3}
                    label_button = 'Video 1'
                    button_color = 'yellow' 
                    video_1 = {video_3}    
                    video_2 = ''
                  />
          </div>
          <div className="container-align-center">
              <Table1Row textHeader="Bloqueo opción 3" cellData={bloqueoOpcion_3} headerBackgroundColor="#FCC642" headerColor="black"/>  
          </div>          
          <div className="container-video-align-center">
            <BotonVideo 
                    video = {video_4}
                    label_button = 'Video 1'
                    button_color = 'yellow' 
                    video_1 = {video_4}    
                    video_2 = ''
                  />
          </div>
          <div className="container-align-center">
              <Table1Row textHeader="Opción Bloqueo Complementario" cellData={bloqueoComplementario} headerBackgroundColor="#FCC642" headerColor="black"/>  
          </div>          
          <div className="container-video-align-center">
            <BotonVideo 
                    video = {video_5}
                    label_button = 'Video 1'
                    button_color = 'yellow' 
                    video_1 = {video_5}    
                    video_2 = ''
                  />
          </div>                
        </Container>          
      );
    }

    //--- PAGINA 3 ---
    function InputComponent_3_1() {

      const [peso_local_paciente, setPeso_del_Paciente] = useState(peso_paciente);
    
      const handleBlur = (event) => {
        const newValue = event.target.value;
        setPesoPaciente(newValue.replace('.', ',').replace(/\s/g, ''));
      };
    
      const handleChange = (event) => {
        const newValue = event.target.value;
        setPeso_del_Paciente(newValue);
      };
    
      return (
        <div className="container-align-center">
          <input
            className="input-container_3_1"
            type="text"
            value={peso_local_paciente}
            onBlur={handleBlur}
            onChange={handleChange}
          />
        </div>
      );
    }
     
    function Pagina3() {
      return (
        <Container fluid>
          <div className="container-align-end">
            <div className="custom-button-prev_2_O">
                    <ButtonPrev2 />
            </div>      
            <div classeName="custom-button-next_2">
                    <ButtonNext2 />
            </div>    			  
          </div>
          <div >
              <p class="text_3_1 text_3_1_1">
              <span class="extra-bold">Calculadora</span><br/>
            <span>de&nbsp;anestesia</span><br/>
            locoregional
            </p>
          </div>
          <div className="container-align-center">
            <img src={img4} alt="Epiloc" />
          </div>
          <div >
              <p class="text_3_1 text_3_1_2">
              <span>Introduce el&nbsp;</span>
              <span class="extra-bold">peso&nbsp;</span>
              <span className="fuenteReducida">(kg)<br/></span> 
              del paciente
            </p>
          </div>
          <InputComponent_3_1 />
        </Container>      
      );
    }

    //--- PAGINA 4 ---

    function Pagina4() {
      return (
        <Container fluid>
          <div className="container-align-end">
            <div className="custom-button-prev_2_O">
                    <ButtonPrev2 />
            </div>      
            <div classeName="custom-button-next_2">
                    <ButtonNext2 />
            </div>    			  
          </div>
          <div >
              <p class="text_4_1 text_4_1_1">
              <span class="extra-bold">Calculadora</span><br/>
              <span>de&nbsp;anestesia</span><br/>
              locoregional
            </p>
          </div>
          <div className="container-align-center">
            <img src={img4} alt="Epiloc" />
          </div>
          <div >
              <p class="text_4_1 text_4_1_2">
              <span>Selecciona la técnica<br/>de&nbsp;</span>
              <span class="extra-bold">bloqueo&nbsp;</span>
            </p>
          </div>
          <div className="container-align-center">
            <SelectionTecnicaBloqueo />
          </div>
          <div >
              <p class="text_4_1 text_4_1_3">
              <span>Volumen&nbsp;a&nbsp;administrar</span>
            </p>
          </div>
          <div className="container-align-center">
            <p className="text-container_4_1">{volumenAdministrar}</p>
          </div> 
          <p>
              <span className="fuenteReducidaLateral">{tec_bloqueo_unidad}<br/></span> 
          </p>
        </Container>      
      );
    }

        //--- PAGINA 4 MAXILAR ---

        function Pagina4_maxilar() {
          return (
            <Container fluid>
              <div className="container-align-end">
                <div className="custom-button-prev_2_O">
                        <ButtonPrev2 />
                </div>      
                <div classeName="custom-button-next_2">
                        <ButtonNext2 />
                </div>    			  
              </div>
              <div >
                  <p class="text_4_1 text_4_1_1">
                  <span class="extra-bold">Calculadora</span><br/>
                  <span>de&nbsp;anestesia</span><br/>
                  locoregional
                </p>
              </div>
              <div className="container-align-center">
                <img src={img4} alt="Epiloc" />
              </div>
              <div >
                  <p class="text_4_1 text_4_1_2">
                  <span>Selecciona la técnica<br/>de&nbsp;</span>
                  <span class="extra-bold">bloqueo&nbsp;</span>
                </p>
              </div>
              <div className="container-align-center">
                <SelectionTecnicaBloqueo />
              </div>
              <div >
                  <p class="text_4_1 text_4_1_3">
                  <span>Volumen&nbsp;a&nbsp;administrar</span>
                </p>
              </div>
              <div className="container-align-center">
                <p className="text-container_4_1_1">{volumenAdministrar}&nbsp;+&nbsp;(Peso/100)</p>
              </div> 
              <p>
                  <span className="fuenteReducidaLateral_2">ml<br/></span> 
              </p>
            </Container>      
          );
        }

    //--- PAGINA 5 ---
    function Pagina5() {
      return (
        <Container fluid>
        <div className="container-align-end">
          <div className="custom-button-prev_2_O">
                  <ButtonPrev2 />
          </div>      
          <div classeName="custom-button-next_2">
                  <ButtonNext2 />
          </div>    			  
        </div>
        <div >
            <p class="text_4_1 text_4_1_1">
            <span class="extra-bold">Calculadora</span><br/>
            <span>de&nbsp;anestesia</span><br/>
            locoregional
          </p>
        </div>
        <div className="container-align-center">
          <img src={img4} alt="Epiloc" />
        </div>
        <div >
            <p class="text_4_1 text_4_1_2">
            <span>Selecciona el<br/></span>
            <span class="extra-bold">anestésico&nbsp;</span>
          </p>
        </div>
        <div className="container-align-center">
            <SelectionAnestesico />
        </div>
          <div >
              <p class="text_4_1 text_5_1_3">
              <span>Dosis</span>
            </p>
          </div>
          <div className="container-align-center">
            <p className="text-container_4_1">{Dosis}</p>
          </div> 
          <p>
              <span className="fuenteReducidaLateral">{anestesico_unidades}<br/></span> 
          </p>
        </Container>      
      );
    }

    //--- PAGINA 6 ---
    function Pagina6() {
      return (
        <Container fluid>
        <div className="container-align-end">
          <div className="custom-button-prev_2_O">
                  <ButtonPrev2 />
          </div>      
          <div classeName="custom-button-next_2">
                  <ButtonNext2 />
          </div>    			  
        </div>
        <div >
            <p class="text_4_1 text_4_1_1">
            <span class="extra-bold">Calculadora</span><br/>
            <span>de&nbsp;anestesia</span><br/>
            locoregional
          </p>
        </div>
        <div className="container-align-center">
          <img src={img4} alt="Epiloc" />
        </div>
        <div >
            <p class="text_4_1 text_4_1_2">
            <span>Selecciona el<br/></span>
            <span class="extra-bold">adyuvante&nbsp;</span>
          </p>
        </div>
        <div className="container-align-center">
          <SelectionAdyuvante />            
        </div>
          <div >
              <p class="text_4_1 text_6_1_3">
              <span>Dosis</span>
            </p>
          </div>
          <div className="container-align-center">
            <p className="text-container_6_1">{DosisAdyuvante}</p>
          </div> 
          <p>
              <span className="fuenteReducidaLateral_6">{adyuvante_unidades}<br/></span> 
          </p>
        </Container>      
      );
    }

    //--- PAGINA 7 ---

    const GraficoRectangular = ({ an, ad, sr, altura, anchura }) => {
      const ref = useRef();
  
      useEffect(() => {
          let total = an + ad + sr;
          if (total <= 1.0) {
            total = 1.0;
          } else if (total <= 3.0) {
            total = 3.0;
          } else if (total <= 6.0) {
            total = 6.0;
          } else if (total <= 12.0) {
            total = 12.0;
          } else if (total <= 24.0) {
            total = 24.0;
          } else if (total <= 50.0) {
            total = 50.0;
          } else if (total <= 60.0) {
            total = 60.0;
          } else {
            total = 60.0;
          }

          const data = [
              { name: 'Anestesico', value: an, class: 'bar-an', color: 'purple' },
              { name: 'Adyuvante', value: ad, class: 'bar-ad', color: 'yellow' },
              { name: 'Suero', value: sr, class: 'bar-sr', color: 'gray' }
          ];
  
          const svg = d3.select(ref.current)
              .attr("width", anchura + 20)
              .attr("height", altura + 50); // Increase height to accommodate legend
  
          const x = d3.scaleLinear()
              .domain([0, total])
              .range([0, anchura]);
  
          const ticks = x.ticks();
          // ticks.push(total);
  
          svg.append("g")
              .attr("class", "axis")
              .attr("transform", "translate(10," + (altura / 2 + 30) + ")")
              .call(d3.axisBottom(x).tickValues(ticks).tickFormat(d3.format(".2f")))
              .selectAll("text")
              .attr("transform", "rotate(-90)")
              .attr("dx", "-.8em")
              .attr("dy", "-0.45em")
              .style("text-anchor", "end")
              .attr("font-size", "10px");
  
          let sum = 0;
  
          svg.selectAll(".bar")
              .data(data)
              .enter().append("rect")
              .attr("class", (d) => d.class)
              .attr("x", (d) => {
                  let s = sum;
                  sum += d.value;
                  return x(s) + 10;
              })
              .attr("y", altura / 2 - 49)
              .attr("width", (d) => x(d.value) - x(0))
              .attr("height", 50);
  
          // Legend
          const legend = svg.append('g')
              .attr('transform', `translate(10, ${altura - 180})`) // Adjust the y-coordinate as per your requirement
              .attr('font-family', 'sans-serif')
              .attr('font-size', '10px');
  
              const legendItem = legend.selectAll('.legend-item')
              .data(data)
              .enter().append('g')
              .attr('class', 'legend-item')
              .attr('transform', (d, i) => `translate(${i * 77}, 0)`);  // Adjust the x-coordinate as per your requirement
          
          legendItem.append('rect')
              .attr('x', 0)
              .attr('width', 10)
              .attr('height', 10)
              .style('fill', d => d.color)
              .style('fill-opacity', 1);
  
          legendItem.append('text')
              .attr('x', 15)
              .attr('y', 9)
              .text(d => d.name);
  
      }, [an, ad, sr, altura, anchura]);
  
      return <svg ref={ref} className="grafico"></svg>;
  };

    function Pagina7() {
      return (
        <Container fluid>
          <div className="container-align-end">
            <div className="custom-button-prev_2_2">
                      <ButtonPrev2 />
              </div>     
            </div>
          <div >
            <p class="text_4_1 text_4_1_4">
            <span class="extra-bold">Resultados</span><br/>
          </p>
          <p class="text_7_0">
            <span>Volumen Total en la jeringuilla</span>
          </p>
          <div className="container-align-center">
            <p className="text-container_7_1">{volumen_total}</p>
            <p className="fuenteReducidaLateral_7">ml<br/></p>
          </div> 
        </div>
        <div> 
        <p class="text_7_2">
            <span>Anestésico</span>
          </p>
        </div>
        <div className="container-align-center">
          <p className="text-container_7_3">{anestesico_ml}</p>
          <p className="fuenteReducidaLateral_7_1">ml<br/></p>
          <p className="text-container_7_4 text-container_7_4_1">{anestesico_desc}</p>
        </div> 

        <div> 
        <p class="text_7_2">
            <span>Adyuvante</span>
          </p>
        </div>

        <div className="container-align-center">
          <p className="text-container_7_3">{adyuvante_ml}</p>
          <p className="fuenteReducidaLateral_7_1">ml<br/></p>
          <p className="text-container_7_4 text-container_7_4_2">{adyuvante_desc}</p>
        </div> 

        <div> 
          <p class="text_7_2">
            <span>Suero</span>
          </p>
        </div>
        <div className="container-align-center">
          <p className="text-container_7_3">{suero_ml}</p>
          <p className="fuenteReducidaLateral_7_1">ml<br/></p>
          <p className="text-container_7_4 text-container_7_4_3">{suero_desc}</p>
        </div> 
        <div class="container-align-center">
          <div className="jeringa">
            <img src={img16} alt="Jeringa" />
          </div>
        </div>
        <div className="liquido">
            <GraficoRectangular an={convertirNumeroStringAFloat(anestesico_ml)} ad={convertirNumeroStringAFloat(adyuvante_ml)} sr={convertirNumeroStringAFloat(suero_ml)} altura={500} anchura={210} />
          </div>
        <div className="container-align-center">
          <p className="text-container_7_5">{puntos_inyeccion}</p>
          <p className="text_7_6">puntos<br/>inyección</p>
          <p className="text-container_7_5">{volumen_punto}</p>
          <p className="text_7_6">volumen en cada<br/>punto inyección en ml</p>
        </div> 
        <div> 
          <p class="text_7_7">
            <span>Aguja Recomendada</span>
          </p>
        </div>
        <div className="container-align-center">
          <p className="text-container_7_6">{aguja_rec}</p>
        </div>

        </Container>      
      );
    }

    function Pagina8() {
      return (
        <Container fluid> 
          <div className="container-align-end">
            <ButtonPrevSingle NumPag={1} />
          </div>
          <div className="container-align-center">
            <ButtonLidocaina/>
          </div>
          <div className="container-align-center">
            <ButtonMepivacaina/>
          </div>
          <div className="container-align-center">
            <ButtonBupivacaina/>
          </div>
          <div className="container-align-center">
            <ButtonLevobupivacaina/>
          </div>
          <div className="container-align-center">
            <ButtonRopivacaina/>
          </div>


        </Container>      
      );
    }

    function Pagina9() {
      return (
        <Container fluid className="container-align-end">
          <ButtonPrevSingle NumPag={8} />
        </Container>      
      );
    }

    function Pagina10() {
      return (
        <Container fluid className="container-align-end">
          <ButtonPrevSingle NumPag={8} />
        </Container>      
      );
    }

    function Pagina11() {
      return (
        <Container fluid className="container-align-end">
          <ButtonPrevSingle NumPag={8} />
        </Container>      
      );
    }

    function Pagina12() {
      return (
        <Container fluid className="container-align-end">
          <ButtonPrevSingle NumPag={8} />
        </Container>      
      );
    }

    function Pagina13() {
      return (
        <Container fluid className="container-align-end">
          <ButtonPrevSingle NumPag={8} />
        </Container>      
      );
    }

    function Pagina14() {
      return (
        <Container fluid> 
          <div className="container-align-end">
            <ButtonPrevSingle NumPag={1} />
          </div>
          </Container>      
      );
    }

    function Pagina15() {
      return (
        <Container fluid> 
          <div className="container-align-end">
            <ButtonPrevSingle NumPag={1} />
          </div>
          </Container>      
      );
    }
    function Pagina16() {
      return (
        <Container fluid> 
          <div className="container-align-end">
            <ButtonPrevSingle NumPag={1} />
          </div>
          </Container>      
      );
    }

    function Pagina17() {
      return (
        <Container fluid> 
          <div className="container-align-end">
            <ButtonPrevSingle NumPag={1} />
          </div>
          </Container>      
      );
    }

    function Pagina18() {
      return (
        <Container fluid> 
          <div className="container-align-end">
            <ButtonPrevSingle NumPag={1} />
          </div>
          </Container>      
      );
    }

    // --- PANTALLAS ---
    switch (currentPage) {
      case 0:
        imgSrc = img0;
          pageContent = (
            <div className="pagina_0">
              <Pagina0 />
          </div>
          );

        break;

      case 1:
        imgSrc = img1;
          pageContent = (
            <div className="pagina_1">
              <Pagina1 />
          </div>
          );

        break;
      case 2:
        imgSrc = img2;
        pageContent = (
          <div className="pagina_2">
            <BloqueoContext.Provider value={{ bloqueoOpcion_1, bloqueoOpcion_2, bloqueoOpcion_3, video_1, video_2, video_3, video_4 }}>
              <Pagina2 />
            </BloqueoContext.Provider>
        </div>
        
        );
        break;

      case 3:
        imgSrc = img3;
        pageContent = (
          <div className="pagina_3">
            <Pagina3 />
        </div>
        );
        break;

        case 4:
          imgSrc = img3;
          if (selectedTecnicaBloqueo === "Maxilar abordaje infraorbitario" ||  selectedTecnicaBloqueo === "Maxilar abordaje intraoral" ||  selectedTecnicaBloqueo === "Alveolar inferior abordaje mandibular" ||  selectedTecnicaBloqueo === "Alveolar inferior abordaje mentoniano") {
            // toast.success(peso_paciente)
            pageContent = (
              <div className="pagina_4">
                <Pagina4_maxilar />
            </div>
            );
            break;
          }
          else
          {
            pageContent = (
              <div className="pagina_4r">
                <Pagina4 />
            </div>
            );
            break;          
          }


        case 5:
          imgSrc = img3;
          pageContent = (
            <div className="pagina_5">
              <Pagina5 />
          </div>
        );
        break;

      case 6:
        imgSrc = img3;
        pageContent = (
          <div className="pagina_6">
            <Pagina6 />
        </div>
        );
        break;

        case 7:
          imgSrc = img3;
          pageContent = (
            <div className="pagina_7">
              <Pagina7 />
          </div>
          );
          break;

          case 8:
            imgSrc = img5;
            pageContent = (
              <div className="pagina_8">
                <Pagina8 />
            </div>
            );
            break;

          case 9:
            imgSrc = img6;
            pageContent = (
              <div className="pagina_9">
                <Pagina9 />
            </div>
            );
            break;

          case 10:
            imgSrc = img7;
            pageContent = (
              <div className="pagina_10">
                <Pagina10 />
            </div>
            );
            break;

          case 11:
            imgSrc = img8;
            pageContent = (
              <div className="pagina_11">
                <Pagina11 />
            </div>
            );
            break;

          case 12:
            imgSrc = img9;
            pageContent = (
              <div className="pagina_12">
                <Pagina12 />
            </div>
            );
            break;

          case 13:
            imgSrc = img10;
            pageContent = (
              <div className="pagina_13">
                <Pagina13 />
            </div>
            );
            break;

          case 14:
            imgSrc = img11;
            pageContent = (
              <div className="pagina_14">
                <Pagina14 />
            </div>
            );
            break;    
            
            case 15:
              imgSrc = img12;
              pageContent = (
                <div className="pagina_15">
                  <Pagina15 />
              </div>
              );
              break;
              
              case 16:
                imgSrc = img13;
                pageContent = (
                  <div className="pagina_16">
                    <Pagina16 />
                </div>
                );
                break;    
                              
                case 17:
                  imgSrc = img14;
                  pageContent = (
                    <div className="pagina_17">
                      <Pagina17 />
                  </div>
                  );
                  break;
                  
                  case 18:
                    imgSrc = img15;
                    pageContent = (
                      <div className="pagina_18">
                        <Pagina18 />
                    </div>
                    );
                    break;    
      default:
        imgSrc = null;
        pageContent = null;
    }
    /*<div className="page" style={{ backgroundImage: `url(${imgSrc})` }}>*/
    return (
      <div>
        {(currentPage === 2 || currentPage === 7) ? (
          <div className="page">
            {/* Contenido para la página 2 */
              <img className="imagen" src={imgSrc} alt="" />
            }
          </div>
        ) : (
          <div className="page">
            {/* Contenido para las demás páginas */
              currentPage === 18 ? (
                <img className="imagen_18" src={imgSrc} alt="" />
              ) : (
                <img className="imagen" src={imgSrc} alt="" />
              )
            }
          </div>
        )}
        <div className="button-container">
          {pageContent}
        </div>
      </div>
    );
    
  };

  return (
    <Container fluid onTouchStart={onTouchStart} onTouchMove={onTouchMove}>
      {renderPageContent()}
      <div>
       <ToastContainer
        position="top-center" 
        autoClose={false} 
        hideProgressBar={false} 
        newestOnTop={false} 
        closeOnClick 
        pauseOnFocusLoss 
        draggable 
        pauseOnHover />
      </div>
    </Container>
  );
};

export default App;

